webpackJsonp([2],{

/***/ 103:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__helper_functions_js__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jquery__);











var apiMixins = {
  data: function data() {
    return {
      loading: false,
      posts: [],
      model: {},
      userIsLoggedIn: false,
      xlsxInput: {},
      showPreview: false,
      previewDataSets: {},
      // previewData: [],
      dataSetName: '1',
      englishToGerman: __WEBPACK_IMPORTED_MODULE_8__helper_functions_js__["a" /* default */].englishToGerman(),
      previewColumnSets: {},
      query: { limit: 20, offset: 0, sort: 'day_id', order: 'ASC', freeTextFilters: {}, assocFilters: {}, nChanges: 0 },
      total: 0,
      warnings: [],
      selection: []
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.refreshActiveUser();

            case 2:
              _context.next = 4;
              return _this.getQuery();

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    route: function route() {
      return this.$route;
    },
    previewData: function previewData() {
      return this.previewDataSets[this.dataSetName];
    },
    previewColumns: function previewColumns() {
      return this.previewColumnSets[this.dataSetName];
    },
    sheetOptions: function sheetOptions() {
      var options;
      if (this.experimentName === 'proliferation') {
        options = ['data-transfer'];
      } else if (this.experimentName === 'patient') {
        options = this.sheetNames;
      } else if (['compound', 'ha', 'gf'].includes(this.experimentName)) {
        options = ['compounds', 'HA', 'GF'];
      } else {
        options = [1]; // returns the first sheet in the file
      }
      this.dataSetName = options[0];
      return options;
    },
    nChanges: function nChanges() {
      return this.query.nChanges;
    }
  },
  methods: {
    refreshPosts: function refreshPosts() {
      // I'm only here to suppress a warning
    },
    getQuery: function getQuery() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var postResource, query;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                postResource = __WEBPACK_IMPORTED_MODULE_8__helper_functions_js__["a" /* default */].getPostResource(_this2.$route).replace('exudats/', '');
                _context2.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].getQueryCookie(postResource);

              case 3:
                query = _context2.sent;

                if (!__WEBPACK_IMPORTED_MODULE_9_jquery___default.a.isEmptyObject(query)) _this2.query = query;else _this2.refreshPosts();

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    refreshActiveUser: function refreshActiveUser() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var userInfo;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;
                _context3.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].getUser();

              case 3:
                userInfo = _context3.sent;

                _this3.userIsLoggedIn = !!userInfo;
                _this3.loading = false;

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    populatePostToEdit: function populatePostToEdit(post) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee4() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.meds = post.patient_med;
                _this4.coms = post.patient_com;
                _this4.model = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()({}, post);

              case 3:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    deletePost: function deletePost(id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee5() {
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!confirm('Are you sure you want to delete this post?')) {
                  _context5.next = 5;
                  break;
                }

                // if we are editing a post we deleted, remove it from the form
                if (_this5.model.id === id) {
                  _this5.model = {};
                }
                _context5.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].deletePost(_this5.dataConfig.databaseName, id);

              case 4:
                _this5.refreshPosts(_this5.dataConfig.databaseName);

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    },
    createDataPreview: function createDataPreview(previewSets) {
      var _this6 = this;

      this.sheetNames = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(previewSets);
      var prevDataSets = {};
      var englishToGerman = this.englishToGerman;
      __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(previewSets).forEach(function (key) {
        var dataSet = previewSets[key];
        var previewData = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(dataSet));
        // Create columns for preview table
        var providedCols = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default.a.apply(Object, [{}].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(previewData)))); // get keys of all rows
        var usedHeaders = _this6.route.params.experiment && ['compound', 'ha', 'gf'].includes(_this6.route.params.experiment) ? __WEBPACK_IMPORTED_MODULE_8__helper_functions_js__["a" /* default */].compoundHeaders : _this6.dataConfig.tableHeader;
        var testCols = usedHeaders.filter(function (head) {
          return providedCols.includes(head.db_key);
        });
        _this6.previewColumnSets[key] = testCols.map(function (col) {
          return {
            field: col.db_key,
            title: englishToGerman[col.db_key],
            category: col.category
          };
        });
        _this6.showPreview = true;

        // Create Data for preview table
        previewData = previewData.map(function (patient) {
          var patientKeys = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(patient);
          var patObj = patient;
          patientKeys.forEach(function (patKey) {
            if (Array.isArray(patient[patKey])) {
              patObj[patKey] = patient[patKey].join(', ');
            }
          });
          return patObj;
        });
        prevDataSets[key] = previewData;
      });
      this.previewDataSets = prevDataSets;
    },
    deleteDataPreview: function deleteDataPreview() {
      this.showPreview = false;
      this.newPatients = [];
      this.previewDataSets = {};
      this.previewColumnSets = {};
      this.warnings = [];
      this.$router.go();
    },
    submitFile: function submitFile(resource, isExperiment) {
      var _this7 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee7() {
        var response, currExp, resourceName, xlsxInput;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _this7.loading = true;
                xlsxInput = _this7.xlsxInput;

                if (!isExperiment) {
                  _context7.next = 7;
                  break;
                }

                _context7.next = 5;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(xlsxInput).map(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee6(key) {
                    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            currExp = xlsxInput[key];
                            resourceName = key.replace('compounds', 'compound').replace('data-transfer', 'proliferation').replace('1', 'we');
                            _context6.next = 4;
                            return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].createPosts(resourceName, currExp, true);

                          case 4:
                            response = _context6.sent;

                            __WEBPACK_IMPORTED_MODULE_8__helper_functions_js__["a" /* default */].createUploadFeedback(response);
                            return _context6.abrupt('return', response);

                          case 7:
                          case 'end':
                            return _context6.stop();
                        }
                      }
                    }, _callee6, this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 5:
                _context7.next = 11;
                break;

              case 7:
                _context7.next = 9;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].createPosts(resource, xlsxInput[1]);

              case 9:
                response = _context7.sent;

                __WEBPACK_IMPORTED_MODULE_8__helper_functions_js__["a" /* default */].createUploadFeedback(response);

              case 11:
                _this7.$router.go();

              case 12:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this7);
      }))();
    },
    refreshQuery: function refreshQuery() {
      var _this8 = this;

      return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee8() {
        var postResource;
        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                postResource = __WEBPACK_IMPORTED_MODULE_8__helper_functions_js__["a" /* default */].getPostResource(_this8.$route).replace('exudats/', '');
                _context8.next = 3;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].setQueryCookie({ query: _this8.query, postResource: postResource });

              case 3:
                _this8.dataConfig && _this8.refreshPosts(_this8.dataConfig.databaseName);

              case 4:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this8);
      }))();
    }
  },
  watch: {
    /* query: {
      async handler () {
        // this.refreshQuery()
      },
      deep: false
    }, */
    nChanges: {
      handler: function handler() {
        var _this9 = this;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee9() {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return _this9.refreshQuery();

                case 2:
                case 'end':
                  return _context9.stop();
              }
            }
          }, _callee9, _this9);
        }))();
      },

      deep: false
    },
    route: {
      handler: function handler() {
        var _this10 = this;

        return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.mark(function _callee10() {
          return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _this10.refreshActiveUser();
                  _context10.next = 3;
                  return _this10.getQuery();

                case 3:
                  _this10.query.offset = 0;

                case 4:
                case 'end':
                  return _context10.stop();
              }
            }
          }, _callee10, _this10);
        }))();
      },

      deep: true
      /* previewDataSets: {
        handler () {
          console.log('New Preview')
          this.previewData = this.previewDataSets[this.dataSetName]
        }
      } */
    } }
};

/* harmony default export */ __webpack_exports__["a"] = (apiMixins);

/***/ }),

/***/ 121:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotLoggedIn_vue__ = __webpack_require__(323);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d70efb52_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotLoggedIn_vue__ = __webpack_require__(695);
function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotLoggedIn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d70efb52_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotLoggedIn_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 130:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    leftFixed: Boolean,
    rightFixed: Boolean
  },
  computed: {
    shouldRenderSelection: function shouldRenderSelection() {
      return !this.rightFixed && this.selection;
    }
  }
});

/***/ }),

/***/ 194:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AkribesForm_vue__ = __webpack_require__(324);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba92ce3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AkribesForm_vue__ = __webpack_require__(703);
function injectStyle (ssrContext) {
  __webpack_require__(696)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AkribesForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1ba92ce3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AkribesForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 255:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(38);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  data: function data() {
    return {
      activeUser: null
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.refreshActiveUser();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  watch: {
    // everytime a route is changed refresh the activeUser
    '$route': 'refreshActiveUser'
  },
  methods: {
    login: function login() {
      this.$router.replace('/');
    },
    refreshActiveUser: function refreshActiveUser() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var userInfo;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].getUser();

              case 2:
                userInfo = _context2.sent;

                _this2.activeUser = userInfo;

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    logout: function logout() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].logout();

              case 2:
                _this3.$router.push('/');

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  } // src="vue-multiselect/dist/vue-multiselect.min.css">

});

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(38);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var crypto = __webpack_require__(565);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      username: '',
      password: '',
      displayName: '',
      localRecords: [],
      error: 0
    };
  },
  created: function created() {},

  methods: {
    isEmpty: function isEmpty(word) {
      return word === '' ? 'nicole' : 'nicole-text';
    },
    submitButton: function submitButton() {
      if (this.pwStrategy !== 'sso') this.handleSubmit();
    },
    handleSubmit: function handleSubmit() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var shasum, params, response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                shasum = crypto.createHash('sha256');

                shasum.update(_this.password);
                params = {
                  username: _this.username,
                  password: shasum.digest('hex')
                };
                _context.prev = 3;
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].createPost('login', params);

              case 6:
                response = _context.sent;

                _this.displayName = response.user.givenName;
                _this.$router.replace(_this.$route.query.redirect || '/patient');
                _context.next = 14;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](3);

                _this.error = _context.t0.response.status;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[3, 11]]);
      }))();
    },
    checkIfEmpty: function checkIfEmpty(word) {
      return this.isEmpty(word);
    },
    logout: function logout() {
      this.displayName = '';
      this.$router.replace('/logout');
    },
    toOverview: function toOverview() {
      this.$router.replace(this.$route.query.redirect || '/admin');
    }
  },
  computed: {
    isLoggedIn: function isLoggedIn() {
      return !!this.displayName;
    },
    errorMessage: function errorMessage() {
      var messages = {
        '401': 'Falscher Benutzername oder falsches Passwort!<br>Bitte versuchen Sie es erneut.',
        '500': 'Es liegt ein internes Problem mit dem Server vor.'
      };
      var message = messages[this.error] ? messages[this.error] : 'Ein unerwarteter Fehler ist aufgetreten.';
      return message;
    }
  },
  watch: {}
});

/***/ }),

/***/ 289:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 298:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 312:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_json__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_table_mixins__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_helper_functions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_xlsx__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_xlsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_xlsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NotLoggedIn__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__plugins_AkribesForm__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__plugins_Information__ = __webpack_require__(326);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import readXlsxFile from 'read-excel-file'





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'show-data',
  components: {
    NotLoggedIn: __WEBPACK_IMPORTED_MODULE_10__NotLoggedIn__["a" /* default */],
    FilterTh: function FilterTh() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 153));
    },
    'akribes-form': __WEBPACK_IMPORTED_MODULE_11__plugins_AkribesForm__["a" /* default */],
    'information': __WEBPACK_IMPORTED_MODULE_12__plugins_Information__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_table_mixins__["a" /* default */]],
  data: function data() {
    return {
      columns: [],
      data: [],
      total: 0,
      query: { limit: 20, offset: 0, sort: 'day_id', order: 'ASC', freeTextFilters: {}, assocFilters: {}, nChanges: 0 },
      pageSizeOptions: [5, 10, 20, 50, 100, 200],
      Export: true,
      dataConfig: __WEBPACK_IMPORTED_MODULE_5__config_json___default.a.tab_settings.patient,
      headerLabels: __WEBPACK_IMPORTED_MODULE_5__config_json___default.a.tab_settings.patient.tableHeader.map(function (head) {
        return head.label;
      }),
      categoryNames: __WEBPACK_IMPORTED_MODULE_5__config_json___default.a.tab_settings.patient.tableHeader.filter(function (head) {
        return head.input_type === 'Array';
      }).map(function (head) {
        return head.db_key;
      }),
      newPatients: [],
      categories: {},
      germanToEnglish: {},
      exceptionCategories: ['Heilende Wunde (klinisch)', 'Nicht heilende Wunde (klinisch)', 'Foto wurde gemacht?', 'Heilende Wunde (in vitro)', 'Nicht heilende Wunde (in vitro)'],
      dbBooleanColumns: ['smell', 'pain', 'infection', 'healing', 'photo_exists', 'healing_in_vitro'],
      dbColumns: ['gender', 'patient_id', 'date', 'day_id', 'day_nr', 'age', 'allergies', 'diagnose', 'wound_localization', 'wound_diameter', 'wound_area', 'wound_depth', 'wound_volume', 'other_colors', 'bacteria', 'not_healing_since', 'photo_time', 'photo_path', 'wound_supply', 'comment', 'exudat_amount_swabs'], // Columns in database
      woundImage: '',
      sheetNames: [],
      experimentName: 'patient'
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      var categoryLists;
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.userIsLoggedIn) {
                _context.next = 5;
                break;
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].getCategoryLists(_this.categoryNames);

            case 3:
              categoryLists = _context.sent;

              _this.categories = categoryLists;

            case 5:
              _this.germanToEnglish = __WEBPACK_IMPORTED_MODULE_8__mixins_helper_functions__["a" /* default */].germanToEnglish(_this.dataConfig);

            case 6:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    file: function file() {
      return this.$refs.file;
    },
    routeID: function routeID() {
      return this.$route.params.id;
    }
  },
  methods: {
    refreshPosts: function refreshPosts() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var config, response, dbData, columns, getFilterType, categories, query;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.loading = true;
                config = _this2.dataConfig;
                _context2.prev = 2;
                _context2.next = 5;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].getPosts('patient', _this2.query);

              case 5:
                response = _context2.sent;
                _context2.next = 13;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](2);

                console.log(_context2.t0);
                _this2.loading = false;
                return _context2.abrupt('return');

              case 13:
                if ((typeof response === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(response)) === 'object') {
                  // typeof response === 'string' if not logged in -> throws error
                  dbData = response.result;
                  columns = response.columns;
                  getFilterType = _this2.getFilterType;
                  categories = _this2.categories;
                  query = _this2.query;

                  _this2.columns = config.tableHeader.map(function (header, idx) {
                    var isVisible = __WEBPACK_IMPORTED_MODULE_8__mixins_helper_functions__["a" /* default */].columnIsVisible(columns, header.db_key, header.visible, query.assocFilters.medication);
                    return {
                      title: header.label,
                      field: header.db_key,
                      visible: isVisible,
                      isChecked: isVisible,
                      category: header.category,
                      sortable: !['Array', 'Assocs'].includes(header.input_type),
                      thComp: ['Image', 'Time', 'Assocs'].includes(header.input_type) ? '' : 'FilterTh',
                      filterType: getFilterType(header.input_type),
                      items: categories[header.db_key]
                    };
                  });
                  _this2.data = dbData.rows;
                  _this2.total = dbData.count;
                }
                _this2.loading = false;

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 8]]);
      }))();
    },
    uploadPatientFile: function uploadPatientFile() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var inputRows, patientResponse;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.loading = true;
                inputRows = [].concat.apply([], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(_this3.xlsxInput));
                _context3.next = 4;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].createPosts('patient', inputRows);

              case 4:
                patientResponse = _context3.sent;

                __WEBPACK_IMPORTED_MODULE_8__mixins_helper_functions__["a" /* default */].createUploadFeedback(patientResponse);
                _this3.newPatients = [];
                _this3.xlsxInput = {};
                _context3.next = 10;
                return _this3.refreshPosts();

              case 10:
                _this3.deleteDataPreview();
                _this3.loading = false;

              case 12:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getFilterType: function getFilterType(inputType) {
      return ['Boolean', 'Date', 'ComputedDate', 'Array', 'Number', 'ComputedNumber'].includes(inputType) ? inputType : 'FreeText';
    },
    convertRowsToFormedInput: function convertRowsToFormedInput(rows, name) {
      var _this4 = this;

      var that = this;
      var engCategory;
      var nMeasurements = rows[0].filter(function (row) {
        return row;
      }).length; // Count not-nulls in first row
      var inputCategories = rows.map(function (row) {
        return row[1];
      });
      inputCategories[0] = 'Tages-ID';
      inputCategories[1] = 'Tag';
      var configCategories = that.dataConfig.tableHeader.map(function (head) {
        return head.label;
      });
      for (var i = 0; i < nMeasurements; i++) {
        // Iterate over measurement columns
        var formedInput = {};
        that.categoryNames.forEach(function (cat) {
          formedInput[cat] = [];
        });
        rows.forEach(function (row, rowInd) {
          // Iterate over measured values
          var inputCategory = inputCategories[rowInd];
          if (inputCategory) inputCategory = inputCategory.trim();
          var value = row[2 + i]; // Two description columns, then measurement columns
          var isX = false;
          if (typeof value === 'string') {
            value = value.trim();
            isX = value.toLowerCase() === 'x';
          }

          // Add to Formed Input
          if (isX && that.exceptionCategories.includes(inputCategory)) {
            // engCategory expected to contain Boolean values
            engCategory = that.germanToEnglish[__WEBPACK_IMPORTED_MODULE_8__mixins_helper_functions__["a" /* default */].capitalizeFirstLetter(inputCategory.replace('Nicht ', ''))];
            if (!that.dbBooleanColumns.includes(engCategory)) {
              that.warnings.push('Tab ' + name + ', ID ' + formedInput.day_id + ' - Problem bei <b>' + inputCategory + '</b>: Unerwarteter Input "' + value + '"');
              console.log('Problem 1');
            }
            formedInput[engCategory] = !inputCategory.includes('Nicht');
          } else if (isX) {
            var revSubRow = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(inputCategories.slice(0, rowInd))).reverse();
            var valueCategory = revSubRow.find(function (cat) {
              return configCategories.includes(cat);
            });
            engCategory = that.germanToEnglish[valueCategory];

            // Test if category and input is valid
            if (!that.headerLabels.includes(inputCategory) && !that.categories[engCategory]) {
              that.warnings.push('Tab ' + name + ', ID ' + formedInput.day_id + ' - Problem bei <b>' + inputCategory + '</b>: Unerwarteter Input "' + value + '"');
              console.log('Problem 2');
            } else {
              if (that.categoryNames.includes(engCategory)) {
                if (typeof formedInput[engCategory] === 'string') formedInput[engCategory] = formedInput[engCategory].split();
                formedInput[engCategory].push(inputCategory);
              } else {
                if (that.dbBooleanColumns.includes(engCategory)) {
                  that.warnings.push('Tab ' + name + ', ID ' + formedInput.day_id + ' - Problem bei <b>' + inputCategory + '</b>: Unerwarteter Input "' + value + '", erwartet: J/N');
                  console.log('Problem 3');
                } else if (!that.dbColumns.includes(engCategory)) {
                  that.warnings.push('Tab ' + name + ', ID ' + formedInput.day_id + ' - Problem bei <b>' + inputCategory + '</b>: Unerwarteter Input "' + value + '"');
                  console.log('Problem 4');
                }
                formedInput[engCategory] = inputCategory;
              }
            }
          } else if (value || value === 0) {
            engCategory = that.germanToEnglish[inputCategory];

            // Test if category and input is valid
            if (inputCategory && !that.headerLabels.includes(inputCategory)) {
              that.warnings.push('Tab ' + name + ', ID ' + formedInput.day_id + ' - Problem bei <b>' + inputCategory + '</b>: Unerwarteter Input "' + value + '" oder unerwartete Kategorie');
              console.log('Problem 5');
            } else if (['medication', 'comorbidity'].includes(engCategory)) {
              formedInput[engCategory] = value.split(', ');
            } else {
              if (['day_nr', 'age'].includes(engCategory)) {
                value = Math.round(value);
              }
              if (!'jJnN'.includes(value)) {
                // engCategory expected to be a dbColumn
                if (inputCategory && !that.dbColumns.includes(engCategory)) {
                  that.warnings.push('Tab ' + name + ', ID ' + formedInput.day_id + ' - Problem bei <b>' + inputCategory + '</b>: Unerwarteter Input "' + value + '"');
                  console.log('Problem 6');
                }
              }
              formedInput[engCategory] = 'jJnN'.includes(value) && _this4.dbBooleanColumns.includes(engCategory) ? 'jJ'.includes(value) : '' + value;
            }
          }
        });
        if (formedInput.gender) formedInput.gender = [formedInput.gender];
        if (formedInput.photo_time) {
          // parses wrong time, for some reasons ...
          var wrongTime = new Date(Math.ceil(parseFloat(formedInput.photo_time) * 1000 * 60 * 60 * 24));
          var hours = wrongTime.getHours();
          formedInput.photo_time = new Date(wrongTime.setHours(hours - 1));
        }

        // Excel saves dates as (number of days after 1.1.1900) + 2
        var dbDate = new Date('12-30-1899');
        dbDate.setDate(dbDate.getDate() + parseInt(formedInput.date));
        formedInput.date = dbDate;

        delete formedInput.undefined;
        that.newPatients.push(formedInput);
      }
      that.xlsxInput[name] = that.newPatients;
      that.newPatients = [];
    },
    loadTextFromFile: function loadTextFromFile() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var input, convertRowsToFormedInput, that, reader;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // File has a complicated format, thus it needs a complex method to read it
                _this5.loading = true;
                input = _this5.file.files[0];
                convertRowsToFormedInput = _this5.convertRowsToFormedInput;
                that = _this5;
                reader = new FileReader();

                reader.onload = function (e) {
                  var bstr = e.target.result;
                  var workBook = __WEBPACK_IMPORTED_MODULE_9_xlsx___default.a.read(bstr, { type: 'binary' });
                  this.sheetNames = workBook.SheetNames;
                  this.sheetNames.forEach(function (name) {
                    var workSheet = workBook.Sheets[name];
                    var rows = __WEBPACK_IMPORTED_MODULE_9_xlsx___default.a.utils.sheet_to_json(workSheet, { header: 1 });
                    while (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rows.map(function (row) {
                      return row[0];
                    })) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(rows.map(function (row) {
                      return row[1];
                    }))) {
                      rows = rows.map(function (row) {
                        return row.slice(1);
                      });
                    }
                    convertRowsToFormedInput(rows, name);
                  });
                  that.createDataPreview(that.xlsxInput);
                };
                reader.readAsBinaryString(input);
                _this5.loading = false;

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    }
  },
  watch: {
    userIsLoggedIn: function userIsLoggedIn(u) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var categoryLists;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!u) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 3;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].getCategoryLists(_this6.categoryNames);

              case 3:
                categoryLists = _context5.sent;

                _this6.categories = categoryLists;

              case 5:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6);
      }))();
    }
  }
});

/***/ }),

/***/ 322:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotLoggedIn',
  methods: {
    redirectToLogin: function redirectToLogin() {
      this.$router.push({ name: 'Login', query: { redirect: this.$route.path } });
    }
  }
});

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_multiselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuejs_datepicker_dist_locale__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_timepicker__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue2_timepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue2_timepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_timepicker_dist_VueTimepicker_css__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue2_timepicker_dist_VueTimepicker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue2_timepicker_dist_VueTimepicker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ExperimentForm__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Information__ = __webpack_require__(326);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





 // For German Language in Calendar





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'akribes-form',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_5_vue_multiselect___default.a,
    Datepicker: __WEBPACK_IMPORTED_MODULE_8_vuejs_datepicker__["a" /* default */],
    VueTimepicker: __WEBPACK_IMPORTED_MODULE_10_vue2_timepicker___default.a,
    'experiment-form': __WEBPACK_IMPORTED_MODULE_12__ExperimentForm__["a" /* default */],
    'information': __WEBPACK_IMPORTED_MODULE_13__Information__["a" /* default */]
  },
  props: {
    dataConfig: Object,
    containsImages: Boolean,
    routeID: String
  },
  data: function data() {
    return {
      newModel: {
        'unit': __WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__["a" /* default */].compoundToUnit[this.$route.params.experiment]
      },
      de: __WEBPACK_IMPORTED_MODULE_9_vuejs_datepicker_dist_locale__["de"],
      categories: {
        gender: [],
        medication: [],
        comorbidity: [],
        woundkind: [],
        woundcolor: [],
        woundsurrounding: [],
        woundedgequality: [],
        woundedgecondition: [],
        woundgroundtissue: [],
        woundgroundcolor: [],
        exudatquality: [],
        exudatamount: [],
        samplekind: []
      },
      categoryNames: this.dataConfig.tableHeader.filter(function (head) {
        return head.input_type === 'Array';
      }).map(function (head) {
        return head.db_key;
      }),
      chosenImages: [],
      currentUploadSize: 0,
      shownCategories: this.dataConfig.shownCategories
    };
  },
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.postResource === 'patient')) {
                _context.next = 3;
                break;
              }

              _context.next = 3;
              return _this.loadCategories();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    formClass: function formClass() {
      // Patient and Experiment Route have different style than the rest
      if (['patient', 'experiment'].includes(this.$route.name)) {
        return 'col-md-3';
      }
    },
    inputTabs: function inputTabs() {
      return this.dataConfig.tableHeader.filter(function (row) {
        return !['Image', 'Computed', 'ComputedDate', 'ComputedNumber', 'Assocs'].includes(row.input_type);
      });
    },
    dbToModel: function dbToModel() {
      var transDict = {};
      this.categoryNames.forEach(function (name) {
        transDict[__WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__["a" /* default */].getAssociationName(name)] = name;
      });
      return transDict;
    },
    postResource: function postResource() {
      return __WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__["a" /* default */].getPostResource(this.$route);
    },
    availableImages: function availableImages() {
      if (this.newModel.photo_path) {
        return this.newModel.photo_path.split(',');
      }
    },
    imageNames: function imageNames() {
      if (this.availableImages) {
        var images = this.availableImages.map(function (im, ind) {
          return 'Bild ' + (ind + 1);
        });
        this.chosenImages = images;
        return images;
      }
    },
    uploadTooLarge: function uploadTooLarge() {
      return this.currentUploadSize > 12000000;
    }
  },
  methods: {
    computeCurrentUploadSize: function computeCurrentUploadSize() {
      if (this.$refs.woundImage) {
        var woundImage = this.$refs.woundImage.files;
        this.currentUploadSize = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(woundImage).map(function (im) {
          return im.size;
        }).reduce(function (acc, cur) {
          return acc + cur;
        });
      }
    },
    saveFormData: function saveFormData() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var formData, woundImage, imageFileName, uploadImageResponse, editedImageIndices, editedImages, photoTime, newModel, response, nextPath;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                formData = new FormData();

                if (!_this2.containsImages) {
                  _context2.next = 14;
                  break;
                }

                // Handling uploaded image
                woundImage = _this2.$refs.woundImage.files;

                __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(woundImage).forEach(function (image) {
                  formData.append('woundImage', image);
                });
                imageFileName = _this2.newModel.day_id.replaceAll(/[,<>:"/\\|?*]/g, ''); // escape illegal chars

                _context2.next = 7;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].uploadImage(imageFileName, formData);

              case 7:
                uploadImageResponse = _context2.sent;
                // get paths of newly uploaded images
                editedImageIndices = _this2.chosenImages.map(function (im) {
                  return parseInt(im.slice(-1)) - 1;
                });
                editedImages = editedImageIndices.map(function (ind) {
                  return _this2.availableImages[ind];
                }); // get paths of edited images

                _this2.newModel.photo_path = editedImages.concat(uploadImageResponse.map(function (image) {
                  return image.path;
                })).join(', ');
                if (_this2.newModel.photo_path.length === 0) _this2.newModel.photo_path = null;
                photoTime = _this2.newModel.photo_time;

                if (photoTime && (typeof photoTime === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(photoTime)) === 'object') {
                  _this2.newModel.photo_time = photoTime.HH + ':' + photoTime.mm;
                }

              case 14:

                if (!_this2.$route.path.includes('compound')) {
                  delete _this2.newModel.unit;
                }

                newModel = _this2.newModel;

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(newModel).forEach(function (key) {
                  if (typeof newModel[key] === 'string' && !isNaN(newModel[key].replace(',', '.'))) newModel[key] = newModel[key].replace(',', '.');
                });

                if (!_this2.routeID) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 20;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].updatePost(_this2.postResource, _this2.newModel.id, _this2.newModel);

              case 20:
                response = _context2.sent;
                _context2.next = 26;
                break;

              case 23:
                _context2.next = 25;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].createPost(_this2.postResource, _this2.newModel);

              case 25:
                response = _context2.sent;

              case 26:
                __WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__["a" /* default */].createUploadFeedback(response);
                _this2.newModel = {};

                if (_this2.$route.params.id) {
                  nextPath = _this2.$route.name === 'properties' ? '/patient-properties/' + _this2.postResource : '/' + _this2.postResource;

                  _this2.$router.push(nextPath);
                }
                _this2.$router.go();

              case 30:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    loadCategories: function loadCategories() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var categoryLists;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].getCategoryLists(_this3.categoryNames);

              case 2:
                categoryLists = _context3.sent;

                _this3.categories = categoryLists;

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    getModelByID: function getModelByID(id) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var newModel, model, arrayKeys;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!id) {
                  _context4.next = 11;
                  break;
                }

                newModel = {};
                _context4.next = 4;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].getPost(_this4.postResource, id);

              case 4:
                model = _context4.sent;

                newModel = model;
                arrayKeys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(model).filter(function (key) {
                  return Array.isArray(model[key]);
                }); // get all keys with Array values

                arrayKeys.forEach(function (key) {
                  newModel[_this4.dbToModel[key]] = model[key].map(function (obj) {
                    return obj.option;
                  });
                  delete newModel[key];
                });
                _this4.newModel = newModel;
                _context4.next = 12;
                break;

              case 11:
                _this4.newModel = {};

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    },
    getPropertyByID: function getPropertyByID(id) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee5() {
        var dbID, newModel, model;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!id) {
                  _context5.next = 12;
                  break;
                }

                dbID = _this5.$route.params.db_id;
                newModel = {};
                _context5.next = 5;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].getPost(dbID, id);

              case 5:
                model = _context5.sent;

                newModel.id = model.id;
                newModel.option = model.option;
                if (dbID === 'medication') {
                  // Medication is associated to effects and substances, while substances again are associated to moas
                  model.substances.forEach(function (substance, ind1) {
                    newModel['wirkstoff_' + (ind1 + 1)] = substance.substance;
                    substance.moas.forEach(function (moa, ind2) {
                      newModel['moa_' + (ind1 + 1) + '_' + (ind2 + 1)] = moa.moa;
                    });
                  });
                  model.effects.forEach(function (effect, ind) {
                    newModel['therapeutischer_effekt_' + (ind + 1)] = effect.effect;
                  });
                }
                _this5.newModel = newModel;
                _context5.next = 13;
                break;

              case 12:
                _this5.newModel = {};

              case 13:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this5);
      }))();
    }
  },
  watch: {
    routeID: function routeID(id) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee6() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(_this6.$route.name === 'properties')) {
                  _context6.next = 5;
                  break;
                }

                _context6.next = 3;
                return _this6.getPropertyByID(id);

              case 3:
                _context6.next = 7;
                break;

              case 5:
                _context6.next = 7;
                return _this6.getModelByID(id);

              case 7:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this6);
      }))();
    }
  }
});

/***/ }),

/***/ 325:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_multiselect__);

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'experiment-form',
  components: {
    Multiselect: __WEBPACK_IMPORTED_MODULE_1_vue_multiselect___default.a
  },
  props: {
    model: Object,
    options: Array,
    dbKey: String,
    unit: String
  },
  data: function data() {
    return {
      chosenOptions: [],
      entries: {}
    };
  },

  methods: {
    resetForm: function resetForm() {
      this.chosenOptions = [];
      this.entries = {};
    }
  },
  watch: {
    entries: function entries(e) {
      this.model[this.dbKey] = e;
    },
    model: function model(m) {
      if (m[this.dbKey]) {
        this.entries = m[this.dbKey];
      }
      if (this.entries) {
        this.chosenOptions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.entries);
      }
    }
  }
});

/***/ }),

/***/ 326:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Information_vue__ = __webpack_require__(327);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127154ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Information_vue__ = __webpack_require__(702);
function injectStyle (ssrContext) {
  __webpack_require__(701)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Information_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_127154ae_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Information_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 327:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'information',
  props: {
    infoText: { type: String, required: true },
    extraStyles: String
  },
  data: function data() {
    return {
      infoDisplay: false
    };
  }
});

/***/ }),

/***/ 328:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_json__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotLoggedIn__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_table_mixins__ = __webpack_require__(103);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import $ from 'jquery'

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NotLoggedIn: __WEBPACK_IMPORTED_MODULE_1__NotLoggedIn__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_table_mixins__["a" /* default */]],
  data: function data() {
    return {
      tabNames: __WEBPACK_IMPORTED_MODULE_0__config_json___default.a.exudats
    };
  }
});

/***/ }),

/***/ 329:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_json__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_table_mixins__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__plugins_AkribesForm__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_read_excel_file__ = __webpack_require__(330);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Proliferation-Assay',
  components: {
    'akribes-form': __WEBPACK_IMPORTED_MODULE_7__plugins_AkribesForm__["a" /* default */],
    FilterTh: function FilterTh() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 153));
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_table_mixins__["a" /* default */]],
  data: function data() {
    return {
      columns: [],
      data: [],
      model: {},
      total: 0,
      germanToEnglish: __WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__["a" /* default */].germanToEnglish(this.dataConfig),
      query: { limit: 20, offset: 0, sort: 'exudate', order: 'ASC', freeTextFilters: {}, assocFilters: {} }
    };
  },

  computed: {
    routeID: function routeID() {
      return this.$route.params.id;
    },
    experimentName: function experimentName() {
      return this.$route.params.experiment;
    },
    dataConfig: function dataConfig() {
      return __WEBPACK_IMPORTED_MODULE_3__config_json___default.a.exudats[this.experimentName];
    },
    file: function file() {
      return this.$refs.file;
    }
  },
  methods: {
    refreshPosts: function refreshPosts() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var config, sortVal, serverQuery, allConcentrations, relevantConcentrations, response, dbData, columns;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                config = _this.dataConfig;
                sortVal = _this.query.sort;
                serverQuery = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.query);

                if (sortVal.includes('concentration_')) {
                  // Sort not only by chosen concentration, but also by all the lower ones
                  allConcentrations = config.tableHeader.map(function (head) {
                    return head.db_key;
                  }).filter(function (head) {
                    return head.includes('concentration_');
                  });
                  relevantConcentrations = allConcentrations.slice(allConcentrations.indexOf(sortVal));

                  serverQuery.sort = relevantConcentrations;
                }
                serverQuery.order += ' NULLS LAST';
                _context.prev = 6;
                _context.next = 9;
                return __WEBPACK_IMPORTED_MODULE_4__api__["a" /* default */].getPosts('exudats/' + _this.experimentName, serverQuery);

              case 9:
                response = _context.sent;
                _context.next = 16;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                _this.loading = false;
                return _context.abrupt('return');

              case 16:
                dbData = response.result;
                columns = response.columns;

                _this.columns = config.tableHeader.map(function (header) {
                  return {
                    title: header.label,
                    field: header.db_key,
                    visible: __WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__["a" /* default */].columnIsVisible(columns, header.db_key, header.visible),
                    isChecked: __WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__["a" /* default */].columnIsVisible(columns, header.db_key, header.visible),
                    sortable: true,
                    category: header.category,
                    thComp: 'FilterTh',
                    filterType: header.input_type === 'Number' ? 'Number' : 'FreeText'
                  };
                });
                _this.data = dbData.rows;
                _this.total = dbData.count;
                _this.loading = false;

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[6, 12]]);
      }))();
    },
    loadTextFromFile: function loadTextFromFile() {
      var _this2 = this;

      var input = this.file;
      var germanToEnglish = this.germanToEnglish;
      this.sheetOptions.forEach(function (op) {
        var currOptions = { sheet: op };
        Object(__WEBPACK_IMPORTED_MODULE_8_read_excel_file__["a" /* default */])(input.files[0], currOptions).then(function (rows) {
          var headers;
          if (_this2.experimentName === 'we') {
            headers = rows[1];
          } else {
            headers = rows[0]; // Table Headers
            var headerIndex = headers.findIndex(function (el) {
              return !el;
            }) - 1;
            var superHeader = headers[headerIndex]; // Super header, such as 'WE concentration (%)'
            var subHeaders = rows[1].filter(function (row) {
              return typeof row === 'number';
            }); // Sub-Headers, such as 8, 4, 2, 1, 0.5
            var unit = rows[1].find(function (el) {
              return typeof el === 'string';
            });

            subHeaders.forEach(function (head, ind) {
              headers[ind + headerIndex] = superHeader + ': ' + head;
            });
          }

          rows = rows.slice(2);
          var inputData = rows.map(function (row) {
            var rowObj = {};
            headers.forEach(function (head, idx) {
              if (row[idx] !== null) {
                rowObj[germanToEnglish[head]] = '' + row[idx];
              }
              if (unit) {
                rowObj.unit = unit;
              }
            });
            delete rowObj.undefined;
            return rowObj;
          });
          _this2.xlsxInput[op] = inputData;
          _this2.createDataPreview(_this2.xlsxInput);
        }).catch(function (err) {
          console.log(err);
          alert('Sheet ' + op + ' wurde nicht gefunden. \xDCberpr\xFCfen Sie ggfs. die Sheet-Namen in der Datei.');
        });
      });
    }
  },
  watch: {
    experimentName: function experimentName() {
      this.query.sort = 'exudate';
      this.refreshPosts();
    }
  }
});

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_json__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotLoggedIn__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mixins_table_mixins__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_helper_functions__ = __webpack_require__(53);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    NotLoggedIn: __WEBPACK_IMPORTED_MODULE_5__NotLoggedIn__["a" /* default */],
    FilterTh: function FilterTh() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 153));
    }
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__mixins_table_mixins__["a" /* default */]],
  data: function data() {
    return {
      tabNames: {
        patient: { title: 'Patienten-Übersicht' },
        'exudats/proliferation': { title: 'Proliferation-Assay' },
        'exudats/compound': { title: 'Compound-Evaluation' },
        'exudats/ha': { title: 'HA' },
        'exudats/gf': { title: 'GF' },
        'exudats/we': { title: 'WE-Parameter' },
        medication: { title: 'Medikamente' },
        comorbidity: { title: 'Komorbiditäten' }
      },
      loading: false,
      data: [],
      columns: [],
      query: { limit: 20, offset: 0, sort: 'deleted_at', order: 'ASC', freeTextFilters: {}, assocFilters: {}, nChanges: 0 },
      Export: false,
      isTrashBin: true
    };
  },

  computed: {
    isExperiment: function isExperiment() {
      return !!this.$route.params.site;
    },
    tableName: function tableName() {
      var params = this.$route.params;
      return this.isExperiment ? params.site + '/' + params.table : params.table;
    },
    dataConfig: function dataConfig() {
      return this.isExperiment ? __WEBPACK_IMPORTED_MODULE_4__config_json___default.a.exudats[this.tableName.replace('exudats/', '')] : __WEBPACK_IMPORTED_MODULE_4__config_json___default.a.tab_settings[this.tableName];
    }
  },
  methods: {
    refreshPosts: function refreshPosts() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var config, trashQuery, tableName, response, dbData, columns;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                config = _this.dataConfig;
                trashQuery = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, _this.query, { trashBin: true });
                tableName = _this.tableName;
                _context.prev = 4;
                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].getPosts(tableName, trashQuery);

              case 7:
                response = _context.sent;
                _context.next = 14;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                _this.loading = false;
                return _context.abrupt('return');

              case 14:
                if ((typeof response === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(response)) === 'object') {
                  // typeof response === 'string' if not logged in -> throws error
                  dbData = response.result;
                  columns = response.columns;

                  _this.columns = config.tableHeader.map(function (header, idx) {
                    var isVisible = __WEBPACK_IMPORTED_MODULE_8__mixins_helper_functions__["a" /* default */].columnIsVisible(columns, header.db_key, header.visible, trashQuery.assocFilters.medications);
                    return {
                      title: header.label,
                      field: header.db_key,
                      visible: isVisible,
                      isChecked: isVisible,
                      category: header.category,
                      sortable: !(['Array', 'Assocs'].includes(header.input_type) || tableName === 'medication'),
                      thComp: ['Image', 'Time', 'Assocs'].includes(header.input_type) ? '' : 'FilterTh',
                      filterType: __WEBPACK_IMPORTED_MODULE_8__mixins_helper_functions__["a" /* default */].getFilterType(header.input_type)
                    };
                  });
                  _this.data = tableName === 'medication' && dbData.rows ? __WEBPACK_IMPORTED_MODULE_8__mixins_helper_functions__["a" /* default */].transformDBToTable(dbData.rows) : dbData.rows;
                  _this.total = dbData.count;
                }
                _this.loading = false;

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[4, 10]]);
      }))();
    }
  },
  watch: {
    tableName: function tableName() {
      this.refreshPosts();
    }
  }
});

/***/ }),

/***/ 337:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_table_mixins__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_helper_functions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_json__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_read_excel_file__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NotLoggedIn__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__plugins_AkribesForm__ = __webpack_require__(194);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'show-data',
  components: {
    NotLoggedIn: __WEBPACK_IMPORTED_MODULE_8__NotLoggedIn__["a" /* default */],
    FilterTh: function FilterTh() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 153));
    },
    'akribes-form': __WEBPACK_IMPORTED_MODULE_9__plugins_AkribesForm__["a" /* default */]
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_table_mixins__["a" /* default */]],
  data: function data() {
    return {
      columns: [],
      data: [],
      total: 0,
      query: { limit: 10, offset: 0, sort: 'option', order: 'ASC', freeTextFilters: {}, assocFilters: {}, nChanges: 0 },
      text: ''
    };
  },

  computed: {
    dbID: function dbID() {
      return this.$route.params.db_id;
    },
    dataConfig: function dataConfig() {
      return __WEBPACK_IMPORTED_MODULE_6__config_json___default.a.tab_settings[this.dbID];
    },
    file: function file() {
      return this.$refs.file;
    },
    routeID: function routeID() {
      return this.$route.params.id;
    },
    LabelToDBKey: function LabelToDBKey() {
      // TO DO: Move this to helpers or similar
      var dict = {};
      this.dataConfig.tableHeader.forEach(function (head) {
        dict[head.label] = head.db_key;
        dict[__WEBPACK_IMPORTED_MODULE_4__mixins_helper_functions__["a" /* default */].replaceSpecialLetters(head.label)] = head.db_key;
      });
      return dict;
    },
    headerLabels: function headerLabels() {
      return this.dataConfig.tableHeader.map(function (head) {
        return head.label;
      });
    }
  },
  methods: {
    refreshPosts: function refreshPosts() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var config, response, dbResult, columns;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.loading = true;
                config = _this.dataConfig;
                _context.prev = 2;
                _context.next = 5;
                return __WEBPACK_IMPORTED_MODULE_5__api__["a" /* default */].getPosts(config.databaseName, _this.query);

              case 5:
                response = _context.sent;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                _this.loading = false;
                return _context.abrupt('return');

              case 12:
                if ((typeof response === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(response)) === 'object') {
                  // typeof response === 'string' if not logged in -> throws error
                  dbResult = response.result;
                  columns = response.columns;

                  _this.columns = config.tableHeader.map(function (header) {
                    var isVisible = __WEBPACK_IMPORTED_MODULE_4__mixins_helper_functions__["a" /* default */].columnIsVisible(columns, header.db_key, header.visible);
                    return {
                      title: header.label,
                      field: header.db_key,
                      category: header.category,
                      sortable: false,
                      visible: isVisible,
                      isChecked: isVisible,
                      thComp: header.db_key === 'option' ? 'FilterTh' : '',
                      isFreeTextFilter: header.label === 'Komorbiditäten'
                    };
                  });
                  _this.data = config.databaseName === 'medication' && dbResult.rows ? __WEBPACK_IMPORTED_MODULE_4__mixins_helper_functions__["a" /* default */].transformDBToTable(dbResult.rows) : dbResult.rows;
                  _this.total = dbResult.count;
                }
                _this.loading = false;

              case 14:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[2, 8]]);
      }))();
    },
    loadTextFromFile: function loadTextFromFile() {
      var _this2 = this;

      var input = this.file;
      var that = this;
      Object(__WEBPACK_IMPORTED_MODULE_7_read_excel_file__["a" /* default */])(input.files[0]).then(function (rows) {
        var headers = rows.shift().map(function (row) {
          return __WEBPACK_IMPORTED_MODULE_4__mixins_helper_functions__["a" /* default */].replaceSpecialLetters(row);
        });
        var inputData = rows.map(function (row) {
          var rowObj = {};
          headers.forEach(function (head, idx) {
            rowObj[that.LabelToDBKey[head]] = row[idx];
          });
          return rowObj;
        });
        _this2.xlsxInput[_this2.dataSetName] = inputData;
        _this2.createDataPreview(_this2.xlsxInput);
      });
    },
    getDbKey: function getDbKey(label) {
      return this.dataConfig.tableHeader.find(function (head) {
        return head.label === label;
      }).db_key;
    }
  },
  watch: {
    dataConfig: function dataConfig() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this3.refreshPosts();

              case 2:
                _this3.query = { limit: 10, offset: 0, sort: 'option', order: 'ASC', freeTextFilters: {}, assocFilters: {}, nChanges: 0 };

              case 3:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3);
      }))();
    }
  }
});

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__ = __webpack_require__(193);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HeaderSettings_index_vue__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__HeaderSettings_MultiSelect_vue__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Table_index_vue__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Pagination_vue__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PageSizeSelect_vue__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ExportButtons_vue__ = __webpack_require__(862);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__mixins_props__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__mixins_helper_functions__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__api__ = __webpack_require__(38);









//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Datatable',
  mixins: [__WEBPACK_IMPORTED_MODULE_15__mixins_props__["a" /* default */]],
  data: function data() {
    return {
      englishToGerman: __WEBPACK_IMPORTED_MODULE_16__mixins_helper_functions__["a" /* default */].englishToGerman()
    };
  },

  components: { HeaderSettings: __WEBPACK_IMPORTED_MODULE_9__HeaderSettings_index_vue__["a" /* default */], MultiSelect: __WEBPACK_IMPORTED_MODULE_10__HeaderSettings_MultiSelect_vue__["a" /* default */], Tbl: __WEBPACK_IMPORTED_MODULE_11__Table_index_vue__["a" /* default */], Pagination: __WEBPACK_IMPORTED_MODULE_12__Pagination_vue__["a" /* default */], PageSizeSelect: __WEBPACK_IMPORTED_MODULE_13__PageSizeSelect_vue__["a" /* default */], ExportButtons: __WEBPACK_IMPORTED_MODULE_14__ExportButtons_vue__["a" /* default */] },
  created: function created() {
    var _this = this;

    // init query (make all the properties observable by using `$set`)
    var q = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_extends___default()({ limit: 20, offset: 0, sort: '', order: '' }, this.query);
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(q).forEach(function (key) {
      _this.$set(_this.query, key, q[key]);
    });
  },

  computed: {
    currentFilters: function currentFilters() {
      var _this2 = this;

      var query = JSON.parse(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_json_stringify___default()(this.query)); // Copy query
      var filterObj = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_assign___default()(query.assocFilters, query.freeTextFilters);
      var filters = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_keys___default()(filterObj).filter(function (key) {
        return filterObj[key] !== undefined;
      });
      return filters.map(function (fil) {
        return {
          label: _this2.englishToGerman[fil],
          db_key: fil
        };
      });
    }
  },
  methods: {
    resetFilter: function resetFilter(fil) {
      this.$delete(this.query.assocFilters, fil);
      this.$delete(this.query.freeTextFilters, fil);
      this.$set(this.query, 'nChanges', this.query.nChanges + 1);
    },
    resetSettings: function resetSettings() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_17__api__["a" /* default */].deleteCookies();

              case 2:
                _this3.$router.go();

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    resetAllFilters: function resetAllFilters() {
      this.$set(this.query, 'assocFilters', {});
      this.$set(this.query, 'freeTextFilters', {});
      this.$set(this.query, 'nChanges', this.query.nChanges + 1);
    },
    restoreSelection: function restoreSelection() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var route, restoreIDs, restoreNames, confMessage, restoreRoute;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                route = _this4.$route;
                restoreIDs = _this4.selection.map(function (item) {
                  return item.id;
                });
                restoreNames = _this4.selection.map(function (item) {
                  return __WEBPACK_IMPORTED_MODULE_16__mixins_helper_functions__["a" /* default */].getName(item);
                });

                // Get confirmation to restore

                if (restoreNames.length === 1) {
                  confMessage = 'Möchten Sie den Eintrag ' + restoreNames[0] + ' wiederherstellen?';
                } else if (restoreNames.length > 1) {
                  confMessage = 'Möchten Sie die Einträge ' + restoreNames.join(', ') + ' wiederherstellen?';
                }

                // Restore Items

                if (!confirm(confMessage)) {
                  _context2.next = 9;
                  break;
                }

                restoreRoute = route.params.table.replace('exudats/', '');
                _context2.next = 8;
                return __WEBPACK_IMPORTED_MODULE_17__api__["a" /* default */].moveToTrashOrRestore(restoreRoute, restoreIDs, route.path.includes('exudats'), true);

              case 8:
                _this4.$router.go();

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    deleteSelection: function deleteSelection(finalRemove) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee4() {
        var route, deletableItems, deletableIDs, undeletableNames, deletableNames, confMessage, deleteRoute;
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                route = _this5.$route;

                // Test which rows can be deleted

                _context4.next = 3;
                return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.all(_this5.selection.map(function () {
                  var _ref = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.mark(function _callee3(item) {
                    var res;
                    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            _context3.next = 2;
                            return __WEBPACK_IMPORTED_MODULE_16__mixins_helper_functions__["a" /* default */].canBeDeleted(item, route);

                          case 2:
                            res = _context3.sent;

                            item.canBeDeleted = res;
                            return _context3.abrupt('return', item);

                          case 5:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, this);
                  }));

                  return function (_x) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 3:
                deletableItems = _context4.sent;

                deletableItems = deletableItems.filter(function (item) {
                  return item.canBeDeleted;
                });
                deletableIDs = deletableItems.map(function (val) {
                  return val.id;
                });
                undeletableNames = _this5.selection.filter(function (item) {
                  return !deletableIDs.includes(item.id);
                }).map(function (el) {
                  return __WEBPACK_IMPORTED_MODULE_16__mixins_helper_functions__["a" /* default */].getName(el);
                });

                // Inform about undeletable items

                if (undeletableNames.length === 1) {
                  alert('Der Eintrag ' + undeletableNames[0] + ' wird von einem oder mehreren Patienten verwendet und kann daher nicht gelöscht werden.');
                } else if (undeletableNames.length > 1) {
                  alert('Die Einträge ' + undeletableNames.join(', ') + ' werden von einem oder mehreren Patienten verwendet und können daher nicht gelöscht werden.');
                }
                deletableNames = deletableItems.map(function (el) {
                  return __WEBPACK_IMPORTED_MODULE_16__mixins_helper_functions__["a" /* default */].getName(el);
                });

                // Get confirmation to delete

                if (deletableNames.length === 1) {
                  confMessage = 'Möchten Sie den Eintrag ' + deletableNames[0] + ' wirklich löschen?';
                  if (finalRemove) confMessage += '\nDieser kann danach nicht wiederhergestellt werden!';
                } else if (deletableNames.length > 1) {
                  confMessage = 'Möchten Sie die Einträge ' + deletableNames.join(', ') + ' wirklich löschen?';
                  if (finalRemove) confMessage += '\nDiese können danach nicht wiederhergestellt werden!';
                }

                // Delete Items

                if (!(confMessage && confirm(confMessage))) {
                  _context4.next = 21;
                  break;
                }

                if (!finalRemove) {
                  _context4.next = 17;
                  break;
                }

                deleteRoute = route.params.table.replace('exudats/', '');
                _context4.next = 15;
                return __WEBPACK_IMPORTED_MODULE_17__api__["a" /* default */].deletePosts(deleteRoute, deletableIDs, route.params.site === 'exudats');

              case 15:
                _context4.next = 20;
                break;

              case 17:
                deleteRoute = __WEBPACK_IMPORTED_MODULE_16__mixins_helper_functions__["a" /* default */].getPostResource(route).replace('exudats/', '');
                _context4.next = 20;
                return __WEBPACK_IMPORTED_MODULE_17__api__["a" /* default */].moveToTrashOrRestore(deleteRoute, deletableIDs, route.name === 'experiment');

              case 20:
                _this5.$router.go();

              case 21:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    }
  },
  watch: {
    data: {
      handler: function handler(data) {
        var _this6 = this;

        var supportNested = this.supportNested;
        // support nested components feature with extra magic

        if (supportNested) {
          var MAGIC_FIELD = '__nested__';
          data.forEach(function (item) {
            if (!item[MAGIC_FIELD]) {
              _this6.$set(item, MAGIC_FIELD, {
                comp: undefined, // current nested component
                visible: false,
                $toggle: function $toggle(comp, visible) {
                  switch (arguments.length) {
                    case 0:
                      this.visible = !this.visible;
                      break;
                    case 1:
                      switch (typeof comp === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(comp)) {
                        case 'boolean':
                          this.visible = comp;
                          break;
                        case 'string':
                        case 'object':
                          this.comp = comp;
                          this.visible = !this.visible;
                          break;
                      }
                      break;
                    case 2:
                      this.comp = comp;
                      this.visible = visible;
                      break;
                  }
                }
              });
              if (supportNested === 'accordion') {
                _this6.$watch(function () {
                  return item[MAGIC_FIELD];
                }, function (nested) {
                  // only one nested component can be expanded at the same time
                  if (data.filter(function (item) {
                    return item[MAGIC_FIELD].visible;
                  }).length < 2) return;

                  data.forEach(function (item) {
                    if (item[MAGIC_FIELD].visible && item[MAGIC_FIELD] !== nested) {
                      item[MAGIC_FIELD].visible = false;
                    }
                  });
                }, { deep: true });
              }
              __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_define_property___default()(item, MAGIC_FIELD, { enumerable: false });
            }
          });
        }
      },

      immediate: true
    }
  }
});

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ColumnGroup_vue__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupBy__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_keyGen__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_replaceWith__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_localstorage__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jquery__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeaderSettings',
  components: { ColumnGroup: __WEBPACK_IMPORTED_MODULE_1__ColumnGroup_vue__["a" /* default */] },
  props: {
    columns: { type: Array, required: true },
    supportBackup: { type: Boolean, required: true }
  },
  data: function data() {
    var origSettings = Object(__WEBPACK_IMPORTED_MODULE_5__utils_localstorage__["e" /* stringify */])(this.columns);
    return {
      origSettings: origSettings,
      usingBak: false, // is using backup
      processingCls: '',
      storageKey: this.supportBackup && Object(__WEBPACK_IMPORTED_MODULE_3__utils_keyGen__["a" /* default */])(origSettings)
    };
  },
  created: function created() {
    if (!this.supportBackup) return;

    var backup = Object(__WEBPACK_IMPORTED_MODULE_5__utils_localstorage__["a" /* getFromLS */])(this.storageKey);
    if (!backup) return; // no backup found

    Object(__WEBPACK_IMPORTED_MODULE_4__utils_replaceWith__["a" /* default */])(this.columns, backup);
    this.usingBak = true;
  },
  mounted: function mounted() {
    // control dropdown manually (refers to http://jsfiddle.net/rj3k550m/3)
    var $el = __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el);
    __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$refs.dropdownBtn).on('click', this.toggle);
    __WEBPACK_IMPORTED_MODULE_6_jquery___default()(document).on('click', function (e) {
      __WEBPACK_IMPORTED_MODULE_6_jquery___default()(e.target).closest($el).length || $el.removeClass('open');
    });
  },

  computed: {
    colGroups: function colGroups() {
      return __WEBPACK_IMPORTED_MODULE_2_lodash_groupBy___default()(this.columns.filter(function (col) {
        return col.label || col.title;
      }), 'group');
    },
    drpMenuStyle: function drpMenuStyle() {
      var w = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.colGroups).length * 150;
      return {
        padding: '10px 10px 0',
        width: w + 25 + 'px',
        left: '-' + (w - 25) + 'px'
      };
    },
    filterIsActive: function filterIsActive() {
      return this.columns.some(function (col) {
        return !col.visible;
      });
    }
  },
  methods: {
    apply: function apply(alsoBackup) {
      this.toggle();
      this.$refs.colGroups.forEach(function (colGroup) {
        colGroup.apply();
      });
      alsoBackup && this.$nextTick(this.backup);
    },
    backup: function backup() {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_localstorage__["d" /* saveToLS */])(this.storageKey, this.columns);
      this.showProcessing();
      this.usingBak = true;
    },
    rmBackup: function rmBackup() {
      Object(__WEBPACK_IMPORTED_MODULE_5__utils_localstorage__["c" /* rmFromLS */])(this.storageKey);
      this.showProcessing();
      this.usingBak = false;

      Object(__WEBPACK_IMPORTED_MODULE_4__utils_replaceWith__["a" /* default */])(this.columns, Object(__WEBPACK_IMPORTED_MODULE_5__utils_localstorage__["b" /* parseStr */])(this.origSettings)); // restore
    },
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_6_jquery___default()(this.$el).toggleClass('open');
    },
    showProcessing: function showProcessing() {
      var _this = this;

      ['fa-spinner fa-pulse', 'fa-check', ''].forEach(function (cls, idx) {
        setTimeout(function () {
          _this.processingCls = cls;
        }, idx * 1000);
      });
    }
  }
});

/***/ }),

/***/ 340:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_isColVisible__ = __webpack_require__(341);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ColumnGroup',
  props: {
    groupName: { type: String, required: true },
    columns: { type: Array, required: true }
  },
  data: function data() {
    return {
      changes: [] // record the changes with a stack
    };
  },
  methods: {
    handleChange: function handleChange(col, isChecked) {
      this.changes.push({ col: col, isChecked: isChecked });
    },
    uuidGen: function uuidGen(key) {
      // $vm._uid is a private property of a Vue instance
      return '-col-' + this._uid + '-' + key;
    },
    apply: function apply() {
      var _this = this;

      this.changes.forEach(function (_ref) {
        var col = _ref.col,
            isChecked = _ref.isChecked;

        _this.$set(col, 'visible', isChecked);
      });
      this.changes = []; // don't forget to clear the stack
    },

    isColVisible: __WEBPACK_IMPORTED_MODULE_0__utils_isColVisible__["a" /* default */]
  }
});

/***/ }),

/***/ 341:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (col) {
  return typeof col.visible === 'undefined' || '' + col.visible === 'true';
});

/***/ }),

/***/ 359:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

/**
 * replace all the elements of target with source's
 * @param {Array} target
 * @param {Array} source
 */
/* harmony default export */ __webpack_exports__["a"] = (function (target, source) {
  target.splice.apply(target, [0, target.length].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(source)));
});

/***/ }),

/***/ 360:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__List_MultiSelect_vue__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_groupBy__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_groupBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_groupBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_helper_functions_js__ = __webpack_require__(53);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MultiSelect',
  components: { ListMS: __WEBPACK_IMPORTED_MODULE_3__List_MultiSelect_vue__["a" /* default */] },
  props: {
    fields: { type: Array, required: true },
    baseWidth: Number,
    radioFilter: Boolean,
    nChanges: Object,
    filteredValue: String
  },
  data: function data() {
    return {
      showDropdown: false,
      globalChanges: {},
      selectedColGroups: [true]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.getSelectedColGroups();
    var $el = __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$el);
    __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$refs.dropdownBtn).on('click', this.toggle);
    __WEBPACK_IMPORTED_MODULE_5_jquery___default()(document).on('click', function (e) {
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()(e.target).closest($el).length || $el.removeClass('open');
      if (__WEBPACK_IMPORTED_MODULE_5_jquery___default()(e.target).closest($el).length === 0) {
        _this.showDropdown = false;
      }
    });
  },

  computed: {
    isWideDropdown: function isWideDropdown() {
      return this.fields.length > 12;
    },
    colGroups: function colGroups() {
      var that = this;
      if (that.isWideDropdown) {
        return __WEBPACK_IMPORTED_MODULE_4_lodash_groupBy___default()(that.fields, 'category');
      } else {
        return __WEBPACK_IMPORTED_MODULE_4_lodash_groupBy___default()(that.fields, 'group');
      }
    },
    allFieldsSelected: function allFieldsSelected() {
      return this.fields.every(function (el) {
        return el.isChecked;
      });
    },
    drpMenuStyle: function drpMenuStyle() {
      var mulWidth = this.categories.length < 4 ? this.categories.length * 220 + 25 : 905;
      return {
        'padding': '10px 10px 0',
        'top': '45px',
        'width': this.hasMultipleGroups ? mulWidth + 'px' : '250px',
        'border-width': '2px',
        'border-style': 'solid',
        'border-color': 'darkgrey',
        'z-index': 2001,
        'background-color': 'white',
        'opacity': 1,
        'position': 'absolute'
      };
    },
    isAllSelected: function isAllSelected() {
      return this.selectedColGroups.every(function (col) {
        return col;
      });
    },
    currentFG: function currentFG() {
      if (this.radioFilter) {
        return this.fields.filter(function (field) {
          return field.visible;
        })[0];
      }
    },
    categories: function categories() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.colGroups);
    },
    hasMultipleGroups: function hasMultipleGroups() {
      return this.categories.length > 1;
    }
  },
  methods: {
    getSelectedColGroups: function getSelectedColGroups() {
      var _this2 = this;

      this.fields.forEach(function (field) {
        _this2.selectedColGroups.push(field.visible);
      });
    },
    selectAllFields: function selectAllFields(allFieldsSelected) {
      var that = this;
      if (allFieldsSelected) {
        that.fields.forEach(function (el) {
          el.isChecked = false;
          that.globalChanges[el.category].push({ el: el, isChecked: false });
        });
      } else {
        that.fields.forEach(function (el) {
          el.isChecked = true;
          that.globalChanges[el.category].push({ el: el, isChecked: true });
        });
      }
    },
    apply: function apply(alsoBackup) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var headerSettings, postResource;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.showDropdown = false;
                _this3.selectedColGroups = [true];
                _this3.toggle();
                _this3.$refs.colGroups.forEach(function (colGroup) {
                  colGroup.apply();
                  !_this3.radioFilter && _this3.selectedColGroups.push(colGroup.test());
                });
                alsoBackup && _this3.$nextTick(_this3.backup);

                // Set Cookie
                headerSettings = {};

                _this3.fields.forEach(function (field) {
                  headerSettings[field.field] = field.visible;
                });
                postResource = __WEBPACK_IMPORTED_MODULE_8__mixins_helper_functions_js__["a" /* default */].getPostResource(_this3.$route).replace('exudats/', '');
                _context.next = 10;
                return __WEBPACK_IMPORTED_MODULE_7__api__["a" /* default */].setConfigCookie({ postResource: postResource, headerSettings: headerSettings });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    toggle: function toggle() {
      __WEBPACK_IMPORTED_MODULE_5_jquery___default()(this.$el).toggleClass('open');
    }
  },
  watch: {
    fields: {
      handler: function handler() {
        this.selectedColGroups = [true];
        this.getSelectedColGroups();
      }
    },
    categories: function categories(categ) {
      var _this4 = this;

      categ.forEach(function (c) {
        // this.globalChanges[c] = []
        __WEBPACK_IMPORTED_MODULE_6_vue__["default"].set(_this4.globalChanges, c, []);
      });
    }
  }
});

/***/ }),

/***/ 361:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ListMS',
  props: {
    groupName: { type: String, required: true },
    elements: { type: Array, required: true },
    globChanges: { type: Array, required: false },
    categories: Array,
    nChanges: Object
  },
  data: function data() {
    return {
      changes: [] // record the changes with a stack
    };
  },
  mounted: function mounted() {
    this.getUnappliedChanges();
  },

  methods: {
    selectAll: function selectAll(isAllSelected) {
      var that = this;
      if (isAllSelected) {
        that.elements.forEach(function (el) {
          el.isChecked = false;
          that.changes.push({ el: el, isChecked: false });
        });
      } else {
        that.elements.forEach(function (el) {
          el.isChecked = true;
          that.changes.push({ el: el, isChecked: true });
        });
      }
    },
    handleChange: function handleChange(el, isChecked) {
      el.isChecked = !el.isChecked;
      this.changes.push({ el: el, isChecked: isChecked });
    },
    uuidGen: function uuidGen(key) {
      return '-col-' + this._uid + '-' + key;
    },
    apply: function apply() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.changes.forEach(function (_ref) {
                  var el = _ref.el,
                      isChecked = _ref.isChecked;

                  _this.$set(el, 'visible', isChecked);
                });
                if (_this.nChanges) _this.nChanges.shown_data += 1;
                _this.changes = []; // don't forget to clear the stack

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    test: function test() {
      return this.isAllSelected;
    },
    getUnappliedChanges: function getUnappliedChanges() {
      for (var i = 0; i < this.elements.length; i++) {
        var el = this.elements[i];
        if (el.isChecked !== el.visible) {
          this.changes.push({ el: el, isChecked: el.isChecked });
        }
      }
    }
  },
  computed: {
    isAllSelected: function isAllSelected() {
      return this.elements.every(function (el) {
        return el.isChecked;
      });
    }
  },
  watch: {
    globChanges: function globChanges(gc) {
      var _this2 = this;

      gc.forEach(function (change) {
        _this2.changes.push(change);
      });
    }
  }
});

/***/ }),

/***/ 362:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TableFrame_vue__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TableHeader_vue__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TableBody_vue__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TableFooter_vue__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_props__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_getScrollWidth__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_isColVisible__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_syncScroll__ = __webpack_require__(850);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Tbl',
  mixins: [__WEBPACK_IMPORTED_MODULE_5__mixins_props__["a" /* default */]],
  components: { TableFrame: __WEBPACK_IMPORTED_MODULE_1__TableFrame_vue__["a" /* default */], TableHeader: __WEBPACK_IMPORTED_MODULE_2__TableHeader_vue__["a" /* default */], TableBody: __WEBPACK_IMPORTED_MODULE_3__TableBody_vue__["a" /* default */], TableFooter: __WEBPACK_IMPORTED_MODULE_4__TableFooter_vue__["a" /* default */] },
  data: function data() {
    return {
      offsetLeft: 0,
      scrollWidth: Object(__WEBPACK_IMPORTED_MODULE_6__utils_getScrollWidth__["a" /* default */])()
    };
  },
  mounted: function mounted() {
    var _this = this;

    // this allows you to fix columns or `fixHeaderAndSetBodyMaxHeight` dynamically
    var unsync = void 0;
    this.$watch('useComplexMode', function (v) {
      if (v) {
        unsync = Object(__WEBPACK_IMPORTED_MODULE_8__utils_syncScroll__["a" /* default */])(_this.$refs.wrappers, function (offsetLeft) {
          _this.offsetLeft = offsetLeft;
        });
      } else {
        unsync && unsync();
      }
    }, { immediate: true });
  },

  computed: {
    visibleColumns: function visibleColumns() {
      return this.columns.filter(__WEBPACK_IMPORTED_MODULE_7__utils_isColVisible__["a" /* default */]);
    },
    leftFixedColumns: function leftFixedColumns() {
      return this.visibleColumns.filter(function (col) {
        return col.fixed && col.fixed !== 'right';
      });
    },
    rightFixedColumns: function rightFixedColumns() {
      return this.visibleColumns.filter(function (col) {
        return col.fixed === 'right';
      });
    },
    hasFixedColumns: function hasFixedColumns() {
      return !!(this.leftFixedColumns.length + this.rightFixedColumns.length);
    },
    useComplexMode: function useComplexMode() {
      return !!(this.fixHeaderAndSetBodyMaxHeight || this.hasFixedColumns);
    },
    propsToNormalTable: function propsToNormalTable() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$props, { columns: this.visibleColumns });
    },
    propsToLeftFixedTable: function propsToLeftFixedTable() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$props, { columns: this.leftFixedColumns });
    },
    propsToRightFixedTable: function propsToRightFixedTable() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.$props, { columns: this.rightFixedColumns });
    }
  }
});

/***/ }),

/***/ 363:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_props__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_shouldRenderSelection__ = __webpack_require__(130);
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TableFrame',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_props__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_shouldRenderSelection__["a" /* default */]]
});

/***/ }),

/***/ 364:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HeadSort_vue__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MultiSelect_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_props__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_shouldRenderSelection__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_json__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__config_json__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TableHeader',
  components: { HeadSort: __WEBPACK_IMPORTED_MODULE_0__HeadSort_vue__["a" /* default */], MultiSelect: __WEBPACK_IMPORTED_MODULE_1__MultiSelect_vue__["a" /* default */] },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__mixins_props__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_shouldRenderSelection__["a" /* default */]],
  data: function data() {
    return {
      shownCategories: __WEBPACK_IMPORTED_MODULE_4__config_json___default.a.tab_settings.patient.shownCategories
    };
  }
});

/***/ }),

/***/ 365:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/**
 * Sorting arrows within <th>
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HeadSort',
  props: {
    field: { type: String, required: true },
    query: { type: Object, required: true }
  },
  data: function data() {
    return {
      order: ''
    };
  },
  computed: {
    cls: function cls() {
      var order = this.order;

      return ['fa', { 'fa-sort text-muted': !order,
        'fa-sort-up': order === 'asc',
        'fa-sort-down': order === 'desc'
      }];
    }
  },
  watch: {
    query: {
      handler: function handler(_ref) {
        var field = _ref.sort,
            order = _ref.order;

        this.order = field === this.field ? order : '';
      },

      deep: true,
      immediate: true
    }
  },
  methods: {
    handleClick: function handleClick() {
      var query = this.query,
          order = this.order;

      query.sort = this.field;
      query.order = this.order = order === 'desc' ? 'asc' : 'desc';
      query.nChanges += 1;
    }
  }
});

/***/ }),

/***/ 366:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelect_vue__ = __webpack_require__(367);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7977c79b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiSelect_vue__ = __webpack_require__(840);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7977c79b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 367:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_replaceWith__ = __webpack_require__(359);
//
//
//


/**
 * checkbox for multiple select within the leading <th>/<td>
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MultiSelect',
  props: {
    selection: { type: Array, required: true },
    row: Object, // available for tbody checkbox
    rows: Array // available for thead checkbox
  },
  data: function data() {
    return {
      status: false
    };
  },
  computed: {
    pos: function pos() {
      var selection = this.selection,
          row = this.row;

      if (!selection || !row) return;
      return selection.indexOf(row);
    }
  },
  methods: {
    toggle: function toggle() {
      var selection = this.selection,
          row = this.row,
          rows = this.rows,
          status = this.status,
          pos = this.pos;

      if (rows) {
        Object(__WEBPACK_IMPORTED_MODULE_0__utils_replaceWith__["a" /* default */])(selection, status ? rows : []);
        return;
      }
      if (row) {
        if (status && pos === -1) selection.push(row);
        if (!status && pos >= 0) selection.splice(pos, 1);
      }
    }
  },
  watch: {
    rows: function rows() {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_replaceWith__["a" /* default */])(this.selection, []);
    },
    selection: function selection(_selection) {
      if (this.row) {
        this.status = this.pos >= 0;
        return;
      }
      if (this.rows) {
        // not only have same length but also non-zero
        this.status = this.rows.length === _selection.length && _selection.length;
      }
    }
  }
});

/***/ }),

/***/ 368:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MultiSelect_vue__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_props__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_shouldRenderSelection__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_pure_lightbox__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_pure_lightbox___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_pure_lightbox__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VuePureLightbox_css__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__VuePureLightbox_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__VuePureLightbox_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_json__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mixins_helper_functions__ = __webpack_require__(53);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




 // For photos





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TableBody',
  components: {
    MultiSelect: __WEBPACK_IMPORTED_MODULE_2__MultiSelect_vue__["a" /* default */],
    VuePureLightbox: __WEBPACK_IMPORTED_MODULE_5_vue_pure_lightbox___default.a
  },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_props__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_shouldRenderSelection__["a" /* default */]],
  data: function data() {
    return {
      objectKeys: ['concentration'] + __WEBPACK_IMPORTED_MODULE_8__config_json___default.a.exudats.proliferation.tableHeader.filter(function (head) {
        return head.input_type === 'Experiment';
      }).map(function (head) {
        return head.db_key;
      })
    };
  },

  computed: {
    colLen: function colLen() {
      return this.columns.length + !!this.selection;
    },
    shownCols: function shownCols() {
      return this.columns.filter(function (col) {
        return !['edit', 'delete'].includes(col.field);
      });
    }
  },
  methods: {
    getListOfImages: function getListOfImages(pathstring) {
      return pathstring.split(',').map(function (im) {
        return im.replace('mounted_data', '/static');
      });
    },
    populatePostToEdit: function populatePostToEdit(item) {
      this.$router.push({ params: { id: '' + item.id } });
    },
    deletePost: function deletePost(item) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var canDelete, deleteRoute, status;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_9__mixins_helper_functions__["a" /* default */].canBeDeleted(item, _this.$route, true);

              case 2:
                canDelete = _context.sent;

                if (!(canDelete && confirm('M\xF6chten Sie den Eintrag ' + (item.option || item.exudate || item.day_id || item.patient_id) + ' wirklich l\xF6schen?'))) {
                  _context.next = 10;
                  break;
                }

                deleteRoute = _this.isTrashBin ? __WEBPACK_IMPORTED_MODULE_9__mixins_helper_functions__["a" /* default */].getPostResource(_this.$route) : __WEBPACK_IMPORTED_MODULE_9__mixins_helper_functions__["a" /* default */].getPostResource(_this.$route).replace('exudats/', '');
                // var status = await api.deletePost(deleteRoute, item.id)

                _context.next = 7;
                return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].moveToTrashOrRestore(deleteRoute, [item.id], _this.$route.path.includes('exudats'), false);

              case 7:
                status = _context.sent;

                _this.createDeleteFeedback(item, status);
                _this.$router.go(); // Refresh page

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    createDeleteFeedback: function createDeleteFeedback(item, status) {
      if (status.err) {
        alert('Der Eintrag ' + (item.option || item.day_id || item.patient_id) + ' konnte nicht gel\xF6scht werden - ' + status.err);
      }
    }
  }
});

/***/ }),

/***/ 369:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_props__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_shouldRenderSelection__ = __webpack_require__(130);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'TableFooter',
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_props__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_shouldRenderSelection__["a" /* default */]]
});

/***/ }),

/***/ 371:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Pagination',
  props: {
    total: { type: Number, required: true },
    query: { type: Object, required: true }
  },
  computed: {
    isFirstPage: function isFirstPage() {
      return +this.query.offset === 0 || +this.query.limit >= this.total;
    },
    isLastPage: function isLastPage() {
      return +this.query.offset + +this.query.limit >= this.total;
    },
    totalPage: function totalPage() {
      return Math.ceil(this.total / +this.query.limit);
    },
    curPage: function curPage() {
      return Math.ceil(+this.query.offset / +this.query.limit) + 1;
    },
    dspBtns: function dspBtns() {
      var n = this.totalPage;
      var i = this.curPage;

      /* eslint-disable */
      if (n <= 9) return function (n) {
        var arr = Array(n);
        while (n) {
          arr[n - 1] = n--;
        }
        return arr;
      }(n);
      if (i <= 5) return [1, 2, 3, 4, 5, 6, 7, 0, n]; // 0 represents `···`
      if (i >= n - 4) return [1, 0, n - 6, n - 5, n - 4, n - 3, n - 2, n - 1, n];
      return [1, 0, i - 2, i - 1, i, i + 1, i + 2, 0, n];
      /* eslint-enable */
    },
    dspBtnObjs: function dspBtnObjs() {
      return this.dspBtns.map(function (btn, i) {
        return { btn: btn, i: i };
      });
    }
  },
  methods: {
    handleClick: function handleClick(n) {
      this.query.offset = (n - 1) * +this.query.limit;
      this.query.nChanges += 1;
    },
    turnPage: function turnPage(i) {
      this.query.nChanges += 1;
      if (i < 0 && this.isFirstPage || i > 0 && this.isLastPage) return;
      this.query.offset = +this.query.offset + i * +this.query.limit;
    }
  }
});

/***/ }),

/***/ 372:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'PageSizeSelect',
  props: {
    query: { type: Object, required: true },
    pageSizeOptions: { type: Array, required: true }
  }
});

/***/ }),

/***/ 373:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_exportCsv_js__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_exportXls_js__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_js__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__ = __webpack_require__(53);



//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ExportButtons',
  props: {
    columns: Array,
    query: Object,
    config: Object,
    selection: Array
  },
  data: function data() {
    return {
      showCSV: false,
      showXLSX: true
    };
  },

  computed: {
    whatIsExported: function whatIsExported() {
      return this.selection.length ? 'Ausgewählte Zeilen ' : 'Alles ';
    },
    postResource: function postResource() {
      return __WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__["a" /* default */].getPostResource(this.$route);
    },
    exportQuery: function exportQuery() {
      var exportQuery = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.query));
      exportQuery.limit = undefined;
      return exportQuery;
    },
    visibleColumns: function visibleColumns() {
      return this.columns.filter(function (col) {
        return col.visible && col.title !== 'Bilder';
      }).map(function (col) {
        return col.title;
      });
    },
    dbToLabel: function dbToLabel() {
      return __WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__["a" /* default */].englishToGerman(this.config);
    }
  },
  methods: {
    getExportData: function getExportData() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var exportData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.selection.length) {
                  _context.next = 4;
                  break;
                }

                exportData = _this.selection;
                _context.next = 8;
                break;

              case 4:
                _context.next = 6;
                return __WEBPACK_IMPORTED_MODULE_5__api_js__["a" /* default */].getPosts(_this.postResource, _this.exportQuery);

              case 6:
                exportData = _context.sent;

                exportData = _this.postResource.includes('medication') ? __WEBPACK_IMPORTED_MODULE_6__mixins_helper_functions__["a" /* default */].transformDBToTable(exportData.result.rows) : exportData.result.rows;

              case 8:

                // Rename column names
                exportData = exportData.map(function (row) {
                  // Augmenting rows isn't necessary any more, as this happens on server side!
                  var newRow = {};
                  for (var key in row) {
                    if (Array.isArray(row[key])) {
                      newRow[_this.dbToLabel[key]] = row[key].join(', ');
                    } else {
                      newRow[_this.dbToLabel[key]] = row[key];
                    }
                  }
                  return newRow;
                });
                return _context.abrupt('return', exportData);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    exportCsv: function exportCsv() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var exportData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this2.getExportData();

              case 2:
                exportData = _context2.sent;

                Object(__WEBPACK_IMPORTED_MODULE_3__utils_exportCsv_js__["a" /* default */])(exportData, _this2.visibleColumns, 'export_' + _this2.postResource);

              case 4:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    exportXlsx: function exportXlsx() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
        var exportData;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.getExportData();

              case 2:
                exportData = _context3.sent;

                Object(__WEBPACK_IMPORTED_MODULE_4__utils_exportXls_js__["a" /* default */])(exportData, _this3.visibleColumns, 'export_' + _this3.postResource);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    }
  }
});

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var client = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  // baseURL: 'http://localhost:8030/',
  json: true
});

// Client-Side requests
/* harmony default export */ __webpack_exports__["a"] = ({
  executeGet: function executeGet(resource, params) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return client({
                method: 'get',
                url: resource,
                params: params
              });

            case 2:
              res = _context.sent;
              return _context.abrupt('return', res.data);

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  executePost: function executePost(resource, data) {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return client({
                method: 'post',
                url: resource,
                data: data
              });

            case 2:
              res = _context2.sent;
              return _context2.abrupt('return', res.data);

            case 4:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }))();
  },
  execute: function execute(method, resource, data) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3() {
      var res;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return client({
                method: method,
                url: resource,
                data: data
              });

            case 2:
              res = _context3.sent;
              return _context3.abrupt('return', res.data);

            case 4:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }))();
  },
  getPosts: function getPosts(resource, params) {
    return this.executeGet('/' + resource, params);
  },
  getPost: function getPost(resource, id) {
    return this.executeGet('/' + resource + '/' + id);
  },
  getCategoryLists: function getCategoryLists(categories) {
    return this.executePost('/categories', { categories: categories });
  },
  getMedicalFilterOptions: function getMedicalFilterOptions() {
    return this.executeGet('/medical-filter-options');
  },
  createPost: function createPost(resource, data) {
    return this.executePost('/' + resource, data);
  },
  uploadImage: function uploadImage(dayID, data) {
    return this.executePost('/image/' + dayID, data);
  },
  createPosts: function createPosts(resource, data, isExperiment) {
    return isExperiment ? this.executePost('/bulk-exudats/' + resource, data) : this.executePost('/bulk-' + resource, data);
  },
  updatePost: function updatePost(resource, id, data) {
    return this.execute('put', '/' + resource + '/' + id, data);
  },
  moveToTrashOrRestore: function moveToTrashOrRestore(resource, ids, isExperiment, restore) {
    var putResource = isExperiment ? '/move-exudats-to-trash-or-restore/' + resource : '/move-to-trash-or-restore/' + resource;
    return this.execute('put', putResource, { ids: ids, restore: restore });
  },
  deletePost: function deletePost(resource, id) {
    return this.execute('delete', '/' + resource + '/' + id);
  },
  deletePosts: function deletePosts(resource, ids, isExperiment) {
    return isExperiment ? this.execute('delete', '/bulk-exudats/' + resource, { ids: ids }) : this.execute('delete', '/bulk-' + resource, { ids: ids });
  },
  getPatientsToAssoc: function getPatientsToAssoc(param, data) {
    return this.executePost('/patients-to-assoc/' + param, data);
  },
  getUser: function getUser() {
    return this.executeGet('user');
  },
  logout: function logout() {
    return this.executePost('logout');
  },
  setConfigCookie: function setConfigCookie(config) {
    return this.executePost('set-columns', config);
  },
  getQueryCookie: function getQueryCookie(postResource) {
    return this.executeGet('query/' + postResource);
  },
  setQueryCookie: function setQueryCookie(query) {
    return this.executePost('set-query', query);
  },
  deleteCookies: function deleteCookies() {
    return this.executePost('delete-cookies');
  }
});

/***/ }),

/***/ 521:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Datatable__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_dist_css_bootstrap_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.






// import 'bootstrap-vue/dist/bootstrap-vue.css'

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3__components_Datatable__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ 523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(255);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43b38626_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(560);
function injectStyle (ssrContext) {
  __webpack_require__(524)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43b38626_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 524:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_json__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__config_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api__ = __webpack_require__(38);








// import _ from 'lodash'
var allHeaders = __WEBPACK_IMPORTED_MODULE_5__config_json___default.a.tab_settings.patient.tableHeader.concat(__WEBPACK_IMPORTED_MODULE_5__config_json___default.a.tab_settings.medication.tableHeader, __WEBPACK_IMPORTED_MODULE_5__config_json___default.a.tab_settings.comorbidity.tableHeader, __WEBPACK_IMPORTED_MODULE_5__config_json___default.a.exudats.proliferation.tableHeader, __WEBPACK_IMPORTED_MODULE_5__config_json___default.a.exudats.compound.tableHeader, __WEBPACK_IMPORTED_MODULE_5__config_json___default.a.exudats.ha.tableHeader, __WEBPACK_IMPORTED_MODULE_5__config_json___default.a.exudats.gf.tableHeader, __WEBPACK_IMPORTED_MODULE_5__config_json___default.a.exudats.we.tableHeader);
var compoundHeaders = [{ 'label': 'Patient pseudonym', 'db_key': 'patient_id', 'input_type': 'String', 'visible': false }, { 'label': 'exudate #', 'db_key': 'exudate', 'input_type': 'String', 'visible': true }, { 'label': 'Cell type', 'db_key': 'cell_type', 'input_type': 'String', 'visible': true }, { 'label': 'Readout', 'db_key': 'readout', 'input_type': 'String', 'visible': true }, { 'label': 'WE concentration (%)', 'db_key': 'we_concentration', 'input_type': 'Number', 'visible': false }, { 'label': 'Compound', 'db_key': 'compound', 'input_type': 'String', 'visible': true }, { 'label': 'concentration: 30000', 'db_key': 'concentration_30000', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 10000', 'db_key': 'concentration_10000', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 3000', 'db_key': 'concentration_3000', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 1000', 'db_key': 'concentration_1000', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 300', 'db_key': 'concentration_300', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 200', 'db_key': 'concentration_200', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 100', 'db_key': 'concentration_100', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 30', 'db_key': 'concentration_30', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 20', 'db_key': 'concentration_20', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 10', 'db_key': 'concentration_10', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 5', 'db_key': 'concentration_5', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 3', 'db_key': 'concentration_3', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 2', 'db_key': 'concentration_2', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 1', 'db_key': 'concentration_1', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 0.5', 'db_key': 'concentration_05', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 0.3', 'db_key': 'concentration_03', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 0.2', 'db_key': 'concentration_02', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 0.1', 'db_key': 'concentration_01', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 0.02', 'db_key': 'concentration_002', 'input_type': 'Number', 'visible': false, 'category': 'Concentration' }, { 'label': 'concentration: 0', 'db_key': 'concentration_0', 'input_type': 'Number', 'visible': true, 'category': 'Concentration' }, { 'label': 'growth factor', 'db_key': 'growth_factor', 'input_type': 'String', 'visible': true }, { 'label': 'Max. Stimulation', 'db_key': 'max_stimulation', 'input_type': 'Number', 'visible': true }, { 'label': 'ED50', 'db_key': 'ed_50', 'input_type': 'String', 'visible': false }, { 'label': 'Max. Inhibition', 'db_key': 'max_inhibition', 'input_type': 'Number', 'visible': false }, { 'label': 'IC50', 'db_key': 'ic_50', 'input_type': 'String', 'visible': false }, { 'label': 'Unit', 'db_key': 'unit', 'input_type': 'String', 'visible': false }, { 'label': 'Exp. #', 'db_key': 'exp', 'input_type': 'String', 'visible': true }, { 'label': 'Comments', 'db_key': 'comment', 'input_type': 'String', 'visible': false }];

var helpers = {
  allHeaders: allHeaders,
  compoundHeaders: compoundHeaders,
  getName: function getName(item) {
    return item.day_id || item.exudate || item.patient_id || item.option;
  },
  replaceSpecialLetters: function replaceSpecialLetters(str) {
    return typeof str === 'string' ? str.replace(/ä/gi, 'ae').replace(/ö/gi, 'oe').replace(/ü/gi, 'ue').replace(/ß/gi, 'ss') : null;
  },
  getAssociationName: function getAssociationName(str) {
    var returnStr = str.slice(-1) === 'y' ? str.slice(0, -1) + 'ie' : str;
    return returnStr.toLowerCase() + 's';
  },
  capitalizeFirstLetter: function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  },
  getPostResource: function getPostResource(route) {
    if (route.name === 'properties') {
      return route.params.db_id;
    } else if (route.name === 'trash') {
      return 'trash-' + route.params.table;
    } else if (route.path.includes('exudats')) {
      return 'exudats/' + route.params.experiment;
    } else {
      return route.name;
    }
  },
  getFilterType: function getFilterType(inputType) {
    return ['Boolean', 'Date', 'ComputedDate', 'Array', 'Number', 'ComputedNumber'].includes(inputType) ? inputType : 'FreeText';
  },
  columnIsVisible: function columnIsVisible(columns, key, visible, medFilter) {
    var config1 = columns[key];
    var config2 = columns[this.getAssociationName(key)];
    if (medFilter && medFilter[key]) {
      return true;
    } else if (typeof config1 !== 'undefined') {
      return config1;
    } else if (typeof config2 !== 'undefined') {
      return config2;
    } else {
      return visible;
    }
  },

  compoundToUnit: {
    compound: 'nM',
    ha: '%',
    gf: 'ng/ml'
  },
  getPlural: function getPlural(str) {
    return str.slice(-1) === 'y' ? str.slice(0, -1) + 'ies' : str + 's';
  },
  germanToEnglish: function germanToEnglish(config) {
    var _this = this;

    config = config ? config.tableHeader : allHeaders;
    var transDict = {};
    config.forEach(function (head) {
      transDict[head.label] = head.db_key;
      transDict[_this.replaceSpecialLetters(head.label)] = head.db_key;
    });
    return transDict;
  },
  englishToGerman: function englishToGerman(config) {
    var _this2 = this;

    config = config ? config.tableHeader : allHeaders;
    var transDict = {};
    config.forEach(function (head) {
      transDict[head.db_key] = head.label;
      transDict[_this2.getPlural(head.db_key.toLowerCase())] = head.label;
    });
    return transDict;
  },
  transformDBToTable: function transformDBToTable(dbData) {
    var transformedData = dbData.map(function (row) {
      var transformedRow = JSON.parse(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()(row));
      transformedRow.substances.forEach(function (substance, sIndex) {
        transformedRow['wirkstoff_' + (sIndex + 1)] = substance.substance;
        substance.moas.forEach(function (moa, mIndex) {
          transformedRow['moa_' + (sIndex + 1) + '_' + (mIndex + 1)] = moa.moa;
        });
      });
      transformedRow.effects.forEach(function (effect, index) {
        transformedRow['therapeutischer_effekt_' + (index + 1)] = effect.effect;
      });
      delete transformedRow.substances;
      delete transformedRow.effects;
      return transformedRow;
    });
    return transformedData;
  },
  createUploadFeedback: function createUploadFeedback(response) {
    response = Array.isArray(response) ? response : [response];
    var errorObjects = response.filter(function (el) {
      return el.err;
    });
    if (errorObjects.length) {
      var errorText = 'Probleme beim Upload der Einträge:';
      errorObjects.forEach(function (obj) {
        try {
          errorText += '\n\n Fehlerhafte Eingabe in Spalte ' + (obj.day_id || obj.patient_id || obj.option);
          console.log(obj);
          // \n (Hinweis: ${obj.err.split(':').slice(-2).join(':')})
        } catch (err) {
          errorText += '\n ' + obj;
        }
      });
      alert(errorText);
    }
    var successObjects = response.filter(function (el) {
      return el && !el.err;
    });
    if (successObjects.length) {
      // Feedback about newly uploaded objects
      var uploadedObjects = successObjects.filter(function (el) {
        return el && el.created;
      }).map(function (el) {
        return el.result.day_id || el.result.exudate || el.result.patient_id || el.result.option || el.result.id + '';
      });
      this.feedbackAlert(uploadedObjects, 'Erfolgreich hochgeladen');

      // Feedback about already existing objects
      var existingObjects = successObjects.filter(function (el) {
        return el && !el.created;
      });
      if (existingObjects.length) {
        if (existingObjects[0].result) {
          // Objects were found and left
          var notChangedObjects = existingObjects.map(function (el) {
            return el.result.day_id || el.result.exudate || el.result.patient_id || el.result.option || el.result.id + '';
          });
          this.feedbackAlert(notChangedObjects, 'Nicht hochgeladen, da bereits vorhanden');
        } else {
          // Objects were edited
          var editedObjects = existingObjects.map(function (el) {
            return el.day_id || el.exudate || el.patient_id || el.option || el.result.id + '';
          });
          this.feedbackAlert(editedObjects, 'Erfolgreich geändert');
        }
      }
    }
  },
  canBeDeleted: function canBeDeleted(item, route, giveAlert) {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
      var patients;
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(route.name === 'properties')) {
                _context.next = 16;
                break;
              }

              _context.next = 3;
              return __WEBPACK_IMPORTED_MODULE_6__api__["a" /* default */].getPatientsToAssoc(route.params.db_id, item);

            case 3:
              patients = _context.sent;

              if (!(patients.length === 1)) {
                _context.next = 8;
                break;
              }

              if (giveAlert) alert('Dieser Eintrag kann nicht gelöscht werden, da er bei Patient ' + patients.map(function (pat) {
                return pat.day_id;
              }) + ' verwendet wird.');
              _context.next = 13;
              break;

            case 8:
              if (!patients.length) {
                _context.next = 12;
                break;
              }

              if (giveAlert) alert('Dieser Eintrag kann nicht gelöscht werden, da er bei den Patienten ' + patients.map(function (pat) {
                return pat.day_id;
              }).join(', ') + ' verwendet wird.');
              _context.next = 13;
              break;

            case 12:
              return _context.abrupt('return', true);

            case 13:
              return _context.abrupt('return', false);

            case 16:
              return _context.abrupt('return', true);

            case 17:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },
  augmentRow: function augmentRow(row) {
    var medicArray = row.medication;
    var substances = [];
    var effects = [];
    var moas = [];
    medicArray.forEach(function (medic) {
      var newSubstances = medic.substances && medic.substances.map(function (sub) {
        return sub.substance;
      });
      substances = substances.concat(newSubstances);
      medic.substances && medic.substances.forEach(function (sub) {
        var newMoas = sub.moas && sub.moas.map(function (moa) {
          return moa.moa;
        });
        moas = moas.concat(newMoas);
      });
      var newEffects = medic.effects && medic.effects.map(function (eff) {
        return eff.effect;
      });
      effects = effects.concat(newEffects);
    });
    row.substance = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(substances))).join(', ');
    row.moa = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(moas))).join(', ');
    row.effect = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(effects))).join(', ');
    return row;
  },
  feedbackAlert: function feedbackAlert(objArray, message) {
    objArray = objArray.filter(function (el) {
      return el && el.length;
    }); // Don't display empty strings
    if (objArray.length === 1) {
      alert(message + ': ' + objArray[0]);
    } else if (objArray.length) {
      alert(message + ': ' + objArray.join(', '));
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (helpers);

/***/ }),

/***/ 560:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-navbar',{attrs:{"toggleable":"md","type":"dark","variant":"dark"}},[_c('b-navbar-toggle',{attrs:{"target":"nav_collapse"}}),_vm._v(" "),_c('b-navbar-brand',{attrs:{"to":"/home"}},[_vm._v("Akribes")]),_vm._v(" "),_c('b-collapse',{attrs:{"is-nav":"","id":"nav_collapse"}},[_c('b-navbar-nav',[_c('b-nav-item',{attrs:{"to":"/home"}},[_vm._v("Home")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/patient"}},[_vm._v("Patienten-Übersicht")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/exudats"}},[_vm._v("Experimente")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/patient-properties/medication"}},[_vm._v("Medikamente")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/patient-properties/comorbidity"}},[_vm._v("Komorbiditäten")]),_vm._v(" "),_c('b-nav-item',{attrs:{"to":"/trash-bin/patient"}},[_vm._v("Papierkorb")]),_vm._v(" "),(!_vm.activeUser)?_c('b-nav-item',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_vm._v("Anmelden")]):_c('b-nav-item',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.logout.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.activeUser)+" abmelden")])],1)],1)],1),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 561:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Login__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Hello__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Patient__ = __webpack_require__(650);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Exudats__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Proliferation__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_TrashBin__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Properties__ = __webpack_require__(721);








// import Compound from '@/components/Compound'
// import WE from '@/components/WE'


__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Login__["a" /* default */]
  }, {
    path: '/home',
    name: 'Hello',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Hello__["a" /* default */]
  }, {
    path: '/patient/:id?',
    name: 'patient',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Patient__["a" /* default */]
  }, {
    path: '/exudats',
    name: 'exudats',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Exudats__["a" /* default */],
    redirect: '/exudats/proliferation',
    children: [{
      path: ':experiment/:id?',
      name: 'experiment',
      component: __WEBPACK_IMPORTED_MODULE_6__components_Proliferation__["a" /* default */]
    }]
  }, {
    path: '/patient-properties/:db_id/:id?',
    name: 'properties',
    component: __WEBPACK_IMPORTED_MODULE_8__components_Properties__["a" /* default */]
  }, {
    path: '/trash-bin/:site?/:table',
    name: 'trash',
    component: __WEBPACK_IMPORTED_MODULE_7__components_TrashBin__["a" /* default */]
  }]
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 563:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(278);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7244c2e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(646);
function injectStyle (ssrContext) {
  __webpack_require__(564)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7244c2e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 564:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 602:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 603:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 604:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 608:
/***/ (function(module, exports) {

module.exports = {"_from":"elliptic@6.5.4","_id":"elliptic@6.5.4","_inBundle":false,"_integrity":"sha512-iLhC6ULemrljPZb+QutR5TQGB+pdW6KGD5RSegS+8sorOZT+rdQFbsQFJgvN3eRqNALqJer4oQ16YvJHlU8hzQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.5.4","name":"elliptic","escapedName":"elliptic","rawSpec":"6.5.4","saveSpec":null,"fetchSpec":"6.5.4"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.5.4.tgz","_shasum":"da37cebd31e79a1367e941b592ed1fbebd58abbb","_spec":"elliptic@6.5.4","_where":"/home/nweibrecht/Dokumente/Akribes/Akribes-App/node_modules/browserify-sign","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"bundleDependencies":false,"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"},"deprecated":false,"description":"EC cryptography","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.5.4"}

/***/ }),

/***/ 609:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 638:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 64:
/***/ (function(module, exports) {

module.exports = {"tab_settings":{"patient":{"title":"Patienten","titleSingular":"Patient","tableHeader":[{"label":"PATIENTEN - ID","db_key":"patient_id","input_type":"String","visible":false,"category":"Patienten-Informationen"},{"label":"Tages-ID","db_key":"day_id","input_type":"String","visible":true,"category":"Patienten-Informationen"},{"label":"Tag","db_key":"day_nr","input_type":"Number","visible":true,"category":"Patienten-Informationen"},{"label":"Datum","db_key":"date","input_type":"Date","visible":false,"category":"Patienten-Informationen"},{"label":"Alter","db_key":"age","input_type":"Number","visible":true,"category":"Patienten-Informationen"},{"label":"Gender","db_key":"gender","input_type":"Array","visible":true,"category":"Patienten-Informationen"},{"label":"Erstellungsdatum","db_key":"created_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Erstellt von","db_key":"user","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Zuletzt geändert","db_key":"updated_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Geändert von","db_key":"changed_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Löschdatum","db_key":"deleted_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Gelöscht von","db_key":"deleted_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederherstellungsdatum","db_key":"restored_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederhergestellt von","db_key":"restored_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Medikamente","db_key":"medication","input_type":"Array","visible":true,"category":"Medikamente"},{"label":"Wirkstoffe","db_key":"substance","input_type":"Assocs","visible":false,"category":"Medikamente"},{"label":"MoAs","db_key":"moa","input_type":"Assocs","visible":false,"category":"Medikamente"},{"label":"Therapeutische Effekte","db_key":"effect","input_type":"Assocs","visible":false,"category":"Medikamente"},{"label":"Komorbiditäten","db_key":"comorbidity","input_type":"Array","visible":true,"category":"Patienten-Informationen"},{"label":"Allergien","db_key":"allergies","input_type":"Textarea","visible":false,"category":"Patienten-Informationen"},{"label":"Diagnose","db_key":"diagnose","input_type":"Textarea","visible":true,"category":"Wunde"},{"label":"Art der Wunde","db_key":"woundkind","input_type":"Array","visible":true,"category":"Wunde"},{"label":"Farbe der Wunde","db_key":"woundcolor","input_type":"Array","visible":false,"category":"Wunde"},{"label":"Lokalisation der Wunde","db_key":"wound_localization","input_type":"Textarea","visible":true,"category":"Wunde"},{"label":"Durchmesser (cm)","db_key":"wound_diameter","input_type":"String","visible":false,"category":"Größe der Wunde"},{"label":"Fläche (cm2)","db_key":"wound_area","input_type":"String","visible":false,"category":"Größe der Wunde"},{"label":"Tiefe (cm)","db_key":"wound_depth","input_type":"String","visible":false,"category":"Größe der Wunde"},{"label":"Volumen (cm3)","db_key":"wound_volume","input_type":"String","visible":false,"category":"Größe der Wunde"},{"label":"Wundumgebung","db_key":"woundsurrounding","input_type":"Array","visible":false,"category":"Wunde"},{"label":"Beschaffenheit","db_key":"woundedgequality","input_type":"Array","visible":false,"category":"Wundrand"},{"label":"Zustand","db_key":"woundedgecondition","input_type":"Array","visible":false,"category":"Wundrand"},{"label":"Gewebsart","db_key":"woundgroundtissue","input_type":"Array","visible":false,"category":"Wundgrund"},{"label":"Farbbeurteilung","db_key":"woundgroundcolor","input_type":"Array","visible":false,"category":"Wundgrund"},{"label":"Sonstige Farben","db_key":"other_colors","input_type":"Textarea","visible":false,"category":"Wundgrund"},{"label":"Qualität","db_key":"exudatquality","input_type":"Array","visible":false,"category":"Exudat"},{"label":"Menge","db_key":"exudatamount","input_type":"Array","visible":false,"category":"Exudat"},{"label":"Geruch","db_key":"smell","input_type":"Boolean","visible":false,"category":"Exudat"},{"label":"Schmerzen?","db_key":"pain","input_type":"Boolean","visible":false,"category":"Komplikationen"},{"label":"Infektion der Wunde?","db_key":"infection","input_type":"Boolean","visible":false,"category":"Komplikationen"},{"label":"Bakterien","db_key":"bacteria","input_type":"Textarea","visible":false,"category":"Komplikationen"},{"label":"Heilende Wunde (klinisch)","db_key":"healing","input_type":"Boolean","visible":true,"category":"Heilungsverlauf"},{"label":"Nicht heilend seit","db_key":"not_healing_since","input_type":"String","visible":false,"category":"Heilungsverlauf"},{"label":"Foto wurde gemacht?","db_key":"photo_exists","input_type":"Boolean","visible":false,"category":"Foto"},{"label":"Uhrzeit der Fotografie","db_key":"photo_time","input_type":"Time","visible":false,"category":"Foto"},{"label":"Bilder","db_key":"photo_path","input_type":"Image","visible":true,"category":"Foto"},{"label":"Wundversorgung","db_key":"wound_supply","input_type":"Textarea","visible":false,"category":"Sonstiges"},{"label":"Kommentar","db_key":"comment","input_type":"Textarea","visible":false,"category":"Sonstiges"},{"label":"Exudatmenge [μl]","db_key":"exudat_amount_swabs","input_type":"Number","visible":false,"category":"Labor"},{"label":"Art der Probe","db_key":"samplekind","input_type":"Array","visible":false,"category":"Labor"},{"label":"Heilende Wunde (in vitro)","db_key":"healing_in_vitro","input_type":"Boolean","visible":false,"category":"Heilungsverlauf"}],"databaseName":"patient","shownCategories":["Wundrand","Wundgrund","Exudat","Komplikationen"]},"medication":{"title":"Medikamente","titleSingular":"Medikament","tableHeader":[{"label":"Medikamente","db_key":"option","input_type":"String","visible":true,"category":"Medikament-Informationen"},{"label":"Wirkstoff 1","db_key":"wirkstoff_1","input_type":"String","visible":true,"category":"Medikament-Informationen"},{"label":"MoA 1/1","db_key":"moa_1_1","input_type":"String","visible":true,"category":"Medikament-Informationen"},{"label":"MoA 1/2","db_key":"moa_1_2","input_type":"String","visible":true,"category":"Medikament-Informationen"},{"label":"Wirkstoff 2","db_key":"wirkstoff_2","input_type":"String","visible":true,"category":"Medikament-Informationen"},{"label":"MoA  2/1","db_key":"moa_2_1","input_type":"String","visible":true,"category":"Medikament-Informationen"},{"label":"MoA  2/2","db_key":"moa_2_2","input_type":"String","visible":true,"category":"Medikament-Informationen"},{"label":"therapeutischer Effekt 1","db_key":"therapeutischer_effekt_1","input_type":"String","visible":true,"category":"Medikament-Informationen"},{"label":"therapeutischer Effekt 2","db_key":"therapeutischer_effekt_2","input_type":"String","visible":true,"category":"Medikament-Informationen"},{"label":"Erstellungsdatum","db_key":"createdAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Erstellt von","db_key":"user","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Zuletzt geändert","db_key":"updatedAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Geändert von","db_key":"changed_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Löschdatum","db_key":"deleted_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Gelöscht von","db_key":"deleted_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederherstellungsdatum","db_key":"restored_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederhergestellt von","db_key":"restored_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"}],"databaseName":"medication"},"comorbidity":{"title":"Komorbiditäten","titleSingular":"Komorbidität","tableHeader":[{"label":"Komorbiditäten","db_key":"option","input_type":"String","visible":true},{"label":"Erstellungsdatum","db_key":"createdAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Erstellt von","db_key":"user","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Zuletzt geändert","db_key":"updatedAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Geändert von","db_key":"changed_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Löschdatum","db_key":"deleted_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Gelöscht von","db_key":"deleted_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederherstellungsdatum","db_key":"restored_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederhergestellt von","db_key":"restored_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"}],"databaseName":"comorbidity"}},"exudats":{"proliferation":{"title":"Proliferation-Assays","titleSingular":"Proliferation-Assay","tableHeader":[{"label":"Patient pseudonym","db_key":"patient_id","input_type":"String","visible":false,"category":"Proliferation-Informationen"},{"label":"exudate #","db_key":"exudate","input_type":"String","visible":true,"category":"Proliferation-Informationen"},{"label":"Cell type","db_key":"cell_type","input_type":"String","visible":true,"category":"Proliferation-Informationen"},{"label":"WE concentration (%): 8","db_key":"we_8","input_type":"Number","visible":true,"category":"Concentration"},{"label":"WE concentration (%): 4","db_key":"we_4","input_type":"Number","visible":true,"category":"Concentration"},{"label":"WE concentration (%): 2","db_key":"we_2","input_type":"Number","visible":true,"category":"Concentration"},{"label":"WE concentration (%): 1","db_key":"we_1","input_type":"Number","visible":true,"category":"Concentration"},{"label":"WE concentration (%): 0.5","db_key":"we_05","input_type":"Number","visible":true,"category":"Concentration"},{"label":"Exp. #","db_key":"exp","input_type":"String","visible":true,"category":"Proliferation-Informationen"},{"label":"PDGF","db_key":"pdgf","input_type":"Number","visible":false,"category":"Proliferation-Informationen"},{"label":"bFGF","db_key":"bfgf","input_type":"Number","visible":false,"category":"Proliferation-Informationen"},{"label":"Rapamycin","db_key":"rapamycin","input_type":"Number","visible":false,"category":"Proliferation-Informationen"},{"label":"Comments","db_key":"comment","input_type":"String","visible":true,"category":"Proliferation-Informationen"},{"label":"Erstellungsdatum","db_key":"createdAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Erstellt von","db_key":"user","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Zuletzt geändert","db_key":"updatedAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Geändert von","db_key":"changed_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Löschdatum","db_key":"deleted_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Gelöscht von","db_key":"deleted_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederherstellungsdatum","db_key":"restored_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederhergestellt von","db_key":"restored_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"}],"arrayOptions":[8,4,2,1,0.5]},"compound":{"title":"Compound-Evaluationen","titleSingular":"Compound-Evaluation","tableHeader":[{"label":"Patient pseudonym","db_key":"patient_id","input_type":"String","visible":false},{"label":"exudate #","db_key":"exudate","input_type":"String","visible":true},{"label":"Cell type","db_key":"cell_type","input_type":"String","visible":true},{"label":"Readout","db_key":"readout","input_type":"String","visible":true},{"label":"WE concentration (%)","db_key":"we_concentration","input_type":"Number","visible":false},{"label":"Compound","db_key":"compound","input_type":"String","visible":true},{"label":"concentration: 100000","db_key":"concentration_100000","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 30000","db_key":"concentration_30000","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 10000","db_key":"concentration_10000","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 3000","db_key":"concentration_3000","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 1000","db_key":"concentration_1000","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 300","db_key":"concentration_300","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 100","db_key":"concentration_100","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 30","db_key":"concentration_30","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 10","db_key":"concentration_10","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 3","db_key":"concentration_3","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 1","db_key":"concentration_1","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 0.3","db_key":"concentration_03","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 0.1","db_key":"concentration_01","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 0","db_key":"concentration_0","input_type":"Number","visible":true,"category":"Concentration"},{"label":"Max. Stimulation","db_key":"max_stimulation","input_type":"Number","visible":true},{"label":"ED50","db_key":"ed_50","input_type":"String","visible":false},{"label":"Max. Inhibition","db_key":"max_inhibition","input_type":"Number","visible":false},{"label":"IC50","db_key":"ic_50","input_type":"String","visible":false},{"label":"Unit","db_key":"unit","input_type":"String","visible":false},{"label":"Exp. #","db_key":"exp","input_type":"String","visible":true},{"label":"Comments","db_key":"comment","input_type":"String","visible":false},{"label":"Erstellungsdatum","db_key":"createdAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Erstellt von","db_key":"user","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Zuletzt geändert","db_key":"updatedAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Geändert von","db_key":"changed_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Löschdatum","db_key":"deleted_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Gelöscht von","db_key":"deleted_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederherstellungsdatum","db_key":"restored_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederhergestellt von","db_key":"restored_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"}]},"ha":{"title":"HA","titleSingular":"HA","tableHeader":[{"label":"Patient pseudonym","db_key":"patient_id","input_type":"String","visible":false},{"label":"exudate #","db_key":"exudate","input_type":"String","visible":true},{"label":"Cell type","db_key":"cell_type","input_type":"String","visible":true},{"label":"Readout","db_key":"readout","input_type":"String","visible":true},{"label":"WE concentration (%)","db_key":"we_concentration","input_type":"Number","visible":false},{"label":"Compound","db_key":"compound","input_type":"String","visible":true},{"label":"concentration: 20","db_key":"concentration_20","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 10","db_key":"concentration_10","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 5","db_key":"concentration_5","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 2","db_key":"concentration_2","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 1","db_key":"concentration_1","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 0.5","db_key":"concentration_05","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 0.2","db_key":"concentration_02","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 0.1","db_key":"concentration_01","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 0","db_key":"concentration_0","input_type":"Number","visible":true,"category":"Concentration"},{"label":"Max. Stimulation","db_key":"max_stimulation","input_type":"Number","visible":true},{"label":"ED50","db_key":"ed_50","input_type":"String","visible":false},{"label":"Max. Inhibition","db_key":"max_inhibition","input_type":"Number","visible":false},{"label":"IC50","db_key":"ic_50","input_type":"String","visible":false},{"label":"Unit","db_key":"unit","input_type":"String","visible":false},{"label":"Exp. #","db_key":"exp","input_type":"String","visible":true},{"label":"Comments","db_key":"comment","input_type":"String","visible":false},{"label":"Erstellungsdatum","db_key":"createdAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Erstellt von","db_key":"user","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Zuletzt geändert","db_key":"updatedAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Geändert von","db_key":"changed_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Löschdatum","db_key":"deleted_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Gelöscht von","db_key":"deleted_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederherstellungsdatum","db_key":"restored_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederhergestellt von","db_key":"restored_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"}]},"gf":{"title":"GF","titleSingular":"GF","tableHeader":[{"label":"Patient pseudonym","db_key":"patient_id","input_type":"String","visible":false},{"label":"exudate #","db_key":"exudate","input_type":"String","visible":true},{"label":"Cell type","db_key":"cell_type","input_type":"String","visible":true},{"label":"Readout","db_key":"readout","input_type":"String","visible":true},{"label":"WE concentration (%)","db_key":"we_concentration","input_type":"Number","visible":true},{"label":"growth factor","db_key":"growth_factor","input_type":"String","visible":true},{"label":"concentration: 200","db_key":"concentration_200","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 20","db_key":"concentration_20","input_type":"Number","visible":true,"category":"Concentration"},{"label":"concentration: 2","db_key":"concentration_2","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 0.2","db_key":"concentration_02","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 0.02","db_key":"concentration_002","input_type":"Number","visible":false,"category":"Concentration"},{"label":"concentration: 0","db_key":"concentration_0","input_type":"Number","visible":true,"category":"Concentration"},{"label":"Max. Stimulation","db_key":"max_stimulation","input_type":"Number","visible":true},{"label":"ED50","db_key":"ed_50","input_type":"String","visible":false},{"label":"Max. Inhibition","db_key":"max_inhibition","input_type":"Number","visible":false},{"label":"IC50","db_key":"ic_50","input_type":"String","visible":false},{"label":"Unit","db_key":"unit","input_type":"String","visible":false},{"label":"Exp. #","db_key":"exp","input_type":"String","visible":true},{"label":"Comments","db_key":"comment","input_type":"String","visible":false},{"label":"Erstellungsdatum","db_key":"createdAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Erstellt von","db_key":"user","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Zuletzt geändert","db_key":"updatedAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Geändert von","db_key":"changed_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Löschdatum","db_key":"deleted_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Gelöscht von","db_key":"deleted_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederherstellungsdatum","db_key":"restored_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederhergestellt von","db_key":"restored_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"}]},"we":{"title":"WE-Parameter","titleSingular":"WE-Parameter","tableHeader":[{"label":"Patient pseudonym","db_key":"patient_id","input_type":"String","visible":false,"category":"General"},{"label":"exudate #","db_key":"exudate","input_type":"String","visible":true,"category":"General"},{"label":"Protein content (mg/ml)","db_key":"protein","input_type":"Number","visible":true,"category":"General"},{"label":"Protein content: exp. #","db_key":"protein_exp","input_type":"String","visible":true,"category":"General"},{"label":"MPO activity (mU/ml)","db_key":"mpo","input_type":"Number","visible":true,"category":"Protease Activities"},{"label":"MPO: exp. #","db_key":"mpo_exp","input_type":"String","visible":true,"category":"Protease Activities"},{"label":"elastase activity (nM)","db_key":"elastase","input_type":"Number","visible":true,"category":"Protease Activities"},{"label":"Elastase: exp. #","db_key":"elastase_exp","input_type":"String","visible":true,"category":"Protease Activities"},{"label":"MMP activity (nM)","db_key":"mmp","input_type":"Number","visible":true,"category":"Protease Activities"},{"label":"MMP: exp. #","db_key":"mmp_exp","input_type":"String","visible":true,"category":"Protease Activities"},{"label":"MMP1","db_key":"mmp_1","input_type":"Number","visible":false,"category":"Protease Proteins"},{"label":"MMP12","db_key":"mmp_12","input_type":"Number","visible":false,"category":"Protease Proteins"},{"label":"MMP13","db_key":"mmp_13","input_type":"Number","visible":false,"category":"Protease Proteins"},{"label":"MMP7","db_key":"mmp_7","input_type":"Number","visible":false,"category":"Protease Proteins"},{"label":"MMP8","db_key":"mmp_8","input_type":"Number","visible":false,"category":"Protease Proteins"},{"label":"MMP2","db_key":"mmp_2","input_type":"Number","visible":false,"category":"Protease Proteins"},{"label":"MMP3","db_key":"mmp_3","input_type":"Number","visible":false,"category":"Protease Proteins"},{"label":"MMP9","db_key":"mmp_9","input_type":"Number","visible":false,"category":"Protease Proteins"},{"label":"Protease proteins: exp. #","db_key":"protease_exp","input_type":"String","visible":false,"category":"Protease Proteins"},{"label":"IL-1a (pg/ml)","db_key":"il_1a","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"IL-1a: exp. #","db_key":"il_1a_exp","input_type":"String","visible":false,"category":"Cytokines"},{"label":"IL-1ß (pg/ml)","db_key":"il_1b","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"IL-1ß: exp. #","db_key":"il_1b_exp","input_type":"String","visible":false,"category":"Cytokines"},{"label":"TNF-a (pg/ml)","db_key":"tnf_a","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"TNF-a: exp. #","db_key":"tnf_a_exp","input_type":"String","visible":false,"category":"Cytokines"},{"label":"IL-6","db_key":"il_6","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"IL-6: exp. #","db_key":"il_6_exp","input_type":"String","visible":false,"category":"Cytokines"},{"label":"IL-8","db_key":"il_8","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"IL-8: exp #","db_key":"il_8_exp","input_type":"String","visible":false,"category":"Cytokines"},{"label":"Eotaxin","db_key":"eotaxin","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"Gro-a","db_key":"gro_a","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"IP-10","db_key":"ip_10","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"MCP-1","db_key":"mcp_1","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"MIP-1a","db_key":"mip_1a","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"MIP-1ß","db_key":"mip_1b","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"Rantes","db_key":"rantes","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"SDF-1a","db_key":"sdf_1a","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"GMCSF","db_key":"gmcfs","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"IL-17A","db_key":"il_17a","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"IL-23","db_key":"il_23","input_type":"Number","visible":false,"category":"Cytokines"},{"label":"Luminex cytokines: exp #","db_key":"lumines_cytokines_exp","input_type":"String","visible":false,"category":"Cytokines"},{"label":"BDNF","db_key":"bdnf","input_type":"Number","visible":false,"category":"GF (Growth Factors)"},{"label":"bNGF","db_key":"bngf","input_type":"Number","visible":false,"category":"GF (Growth Factors)"},{"label":"EGF","db_key":"egf","input_type":"Number","visible":false,"category":"GF (Growth Factors)"},{"label":"FGF2","db_key":"fgf_2","input_type":"Number","visible":false,"category":"GF (Growth Factors)"},{"label":"HGF","db_key":"hgf","input_type":"Number","visible":false,"category":"GF (Growth Factors)"},{"label":"LIF","db_key":"lif","input_type":"Number","visible":false,"category":"GF (Growth Factors)"},{"label":"PDGFBB","db_key":"pdgfbb","input_type":"Number","visible":false,"category":"GF (Growth Factors)"},{"label":"PIGF1","db_key":"pigf_1","input_type":"Number","visible":false,"category":"GF (Growth Factors)"},{"label":"SCF","db_key":"scf","input_type":"Number","visible":false,"category":"GF (Growth Factors)"},{"label":"VEGFa","db_key":"vegf_a","input_type":"Number","visible":false,"category":"GF (Growth Factors)"},{"label":"VEGFd","db_key":"vegf_d","input_type":"Number","visible":false,"category":"GF (Growth Factors)"},{"label":"Luminex GF: exp.#","db_key":"lumines_gf_exp","input_type":"String","visible":false,"category":"GF (Growth Factors)"},{"label":"Erstellungsdatum","db_key":"createdAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Erstellt von","db_key":"user","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Zuletzt geändert","db_key":"updatedAt","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Geändert von","db_key":"changed_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Löschdatum","db_key":"deleted_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Gelöscht von","db_key":"deleted_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederherstellungsdatum","db_key":"restored_at","input_type":"ComputedDate","visible":false,"category":"Datenbank-Informationen"},{"label":"Wiederhergestellt von","db_key":"restored_by","input_type":"Computed","visible":false,"category":"Datenbank-Informationen"}]}}}

/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoggedIn)?_c('div',{},[_c('div',{staticClass:"card login-page"},[_c('div',{staticClass:"card col-md-3 container-fluid already-in"},[_c('div',{staticClass:"card-header"},[_c('p',[_c('label',[_vm._v(" Hallo "+_vm._s(_vm.displayName)+", Sie sind bereits angemeldet! ")])]),_vm._v(" "),_c('label',[_vm._v(" Was möchten Sie tun? ")])]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default akr-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.toOverview()}}},[_vm._v("\n              Zur Übersicht\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default akr-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("\n              Logout\n            ")])])])])])]):_c('div',[_c('div',{staticClass:"login-page"},[_c('form',{staticClass:"col-md-12 login-page",staticStyle:{"padding":"15px"},on:{"submit":function($event){$event.preventDefault();return _vm.submitButton.apply(null, arguments)}}},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card container-fluid",staticStyle:{"width":"325px","padding-left":"35px","padding-right":"35px","border-color":"white"}},[_c('div',{staticClass:"login-box closed"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',[_c('div',{staticClass:"input-group-sm login-field"},[_c('div',{staticClass:"form-control",staticStyle:{"height":"30px"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.username),expression:"username"}],class:_vm.checkIfEmpty(_vm.username),attrs:{"type":"text","placeholder":"Benutzername"},domProps:{"value":(_vm.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.username=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"input-group-sm login-field"},[_c('div',{staticClass:"form-control",staticStyle:{"height":"30px"}},[_c('i',{staticClass:"fa fa-unlock-alt"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.password),expression:"password"}],class:_vm.checkIfEmpty(_vm.password),attrs:{"type":"password","placeholder":"Passwort"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value}}})])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),(_vm.error)?_c('div',{staticClass:"error",domProps:{"innerHTML":_vm._s(_vm.errorMessage)}}):_vm._e()])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid login-seite",staticStyle:{"width":"120px"}},[_c('label',{staticClass:"login-cap"},[_vm._v(" Login ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header"},[_c('p',[_c('label',[_vm._v(" Willkommen! ")])]),_vm._v(" "),_c('label',[_vm._v(" Bitte melden Sie sich an. ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-footer"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"btn btn-default akr-button login-button",attrs:{"type":"submit"}},[_vm._v("\n                    Login\n                  ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 647:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1c3cba8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__ = __webpack_require__(649);
function injectStyle (ssrContext) {
  __webpack_require__(648)
}
var normalizeComponent = __webpack_require__(19)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f1c3cba8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hello_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 648:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 649:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero"},[_c('div',[_c('h1',{staticClass:"display-3"},[_vm._v("Herzlich Willkommen auf der Akribes-Seite!")]),_vm._v(" "),_c('p',{staticClass:"lead"},[_vm._v("Version vom 18.08.2021")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 650:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Patient_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a810d36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Patient_vue__ = __webpack_require__(704);
function injectStyle (ssrContext) {
  __webpack_require__(651)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Patient_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2a810d36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Patient_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 651:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 693:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 695:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid centered col-md-6"},[_c('b-card',[_c('b-card-body',[_c('label',[_vm._v(" Sie müssen "),_c('label',{staticClass:"redirect",on:{"click":_vm.redirectToLogin}},[_vm._v("eingeloggt")]),_vm._v(" sein, um diese Seite zu sehen! ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 696:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 698:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 699:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperimentForm_vue__ = __webpack_require__(325);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76669b7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperimentForm_vue__ = __webpack_require__(700);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExperimentForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_76669b7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExperimentForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 700:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('multiselect',{attrs:{"placeholder":"Bitte auswählen","options":_vm.options,"multiple":true},model:{value:(_vm.chosenOptions),callback:function ($$v) {_vm.chosenOptions=$$v},expression:"chosenOptions"}}),_vm._v(" "),_vm._l((_vm.chosenOptions),function(choice){return _c('b-form-group',{key:choice,staticClass:"col-md-6"},[_c('label',[_vm._v(" WE-Concentration: "+_vm._s(choice)+" "+_vm._s(_vm.unit)+" ")]),_vm._v(" "),_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.entries[choice]),callback:function ($$v) {_vm.$set(_vm.entries, choice, $$v)},expression:"entries[choice]"}})],1)})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 702:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":"Information"}},[_c('i',{staticClass:"fa fa-info-circle info",on:{"mouseover":function($event){_vm.infoDisplay = true},"mouseleave":function($event){_vm.infoDisplay = false}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.infoDisplay),expression:"infoDisplay"}],staticClass:"infobox",style:(_vm.extraStyles)},[_c('p',{staticClass:"infotext"},[_vm._v(" "+_vm._s(_vm.infoText)+" ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 703:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"0"}},[_c('b-card',{attrs:{"title":(_vm.newModel.id ? _vm.dataConfig.titleSingular + ' bearbeiten' : _vm.dataConfig.titleSingular + ' hinzufügen')}},[_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.saveFormData.apply(null, arguments)}}},[_vm._l((_vm.inputTabs),function(head){return _c('b-form-group',{key:head.db_key,class:_vm.formClass},[(_vm.shownCategories && _vm.shownCategories.includes(head.category))?_c('label',{staticStyle:{"text-transform":"none"}},[_vm._v("\n          "+_vm._s(head.category)+":\n        ")]):_vm._e(),_vm._v(" "),_c('label',{staticStyle:{"text-transform":"none"}},[_vm._v(" "+_vm._s(head.label)+" ")]),_vm._v(" "),(['String', 'Number'].includes(head.input_type))?_c('div',[_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.newModel[head.db_key]),callback:function ($$v) {_vm.$set(_vm.newModel, head.db_key, $$v)},expression:"newModel[head.db_key]"}})],1):(head.input_type === 'Array')?_c('div',[_c('multiselect',{attrs:{"placeholder":"Bitte auswählen","options":_vm.categories[head.db_key],"multiple":true},model:{value:(_vm.newModel[head.db_key]),callback:function ($$v) {_vm.$set(_vm.newModel, head.db_key, $$v)},expression:"newModel[head.db_key]"}})],1):(head.input_type === 'Textarea')?_c('div',[_c('b-form-textarea',{model:{value:(_vm.newModel[head.db_key]),callback:function ($$v) {_vm.$set(_vm.newModel, head.db_key, $$v)},expression:"newModel[head.db_key]"}})],1):(head.input_type === 'Boolean')?_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.newModel[head.db_key]),expression:"newModel[head.db_key]"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.newModel[head.db_key])?_vm._i(_vm.newModel[head.db_key],null)>-1:(_vm.newModel[head.db_key])},on:{"change":function($event){var $$a=_vm.newModel[head.db_key],$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.newModel, head.db_key, $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.newModel, head.db_key, $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.newModel, head.db_key, $$c)}}}}),_vm._v(" "+_vm._s((_vm.newModel[head.db_key]) ? 'Ja' : 'Nein')+"\n        ")]):(head.input_type === 'Date')?_c('div',[_c('datepicker',{attrs:{"placeholder":"Bitte auswählen","language":_vm.de,"bootstrap-styling":true},model:{value:(_vm.newModel[head.db_key]),callback:function ($$v) {_vm.$set(_vm.newModel, head.db_key, $$v)},expression:"newModel[head.db_key]"}})],1):(head.input_type === 'Time')?_c('div',[_c('vue-timepicker',{attrs:{"placeholder":"Bitte auswählen"},model:{value:(_vm.newModel[head.db_key]),callback:function ($$v) {_vm.$set(_vm.newModel, head.db_key, $$v)},expression:"newModel[head.db_key]"}})],1):_vm._e()])}),_vm._v(" "),(_vm.newModel.photo_path)?_c('b-form-group',{class:_vm.formClass},[_c('label',[_vm._v(" Gespeicherte Bilder ")]),_vm._v(" "),_c('div',[_c('multiselect',{attrs:{"placeholder":"Keine Bilder ausgewählt","options":_vm.imageNames,"multiple":true},model:{value:(_vm.chosenImages),callback:function ($$v) {_vm.chosenImages=$$v},expression:"chosenImages"}})],1)]):_vm._e(),_vm._v(" "),(!_vm.containsImages)?_c('div',{staticClass:"fields"},[_c('b-btn',{attrs:{"type":"submit","variant":"success"}},[_vm._v(_vm._s(_vm.dataConfig.titleSingular)+" speichern")])],1):_vm._e()],2),_vm._v(" "),(_vm.containsImages)?_c('form',{attrs:{"enctype":"multipart/form-data"},on:{"submit":function($event){$event.preventDefault();return _vm.saveFormData.apply(null, arguments)},"change":_vm.computeCurrentUploadSize}},[_c('label',[_vm._v(" Bilddateien hinzufügen (max. 12 MB) ")]),_vm._v(" "),_c('input',{ref:"woundImage",attrs:{"type":"file","multiple":""}}),_vm._v(" "),_c('div',{staticClass:"fields",staticStyle:{"display":"flex"}},[_c('b-btn',{attrs:{"disabled":_vm.uploadTooLarge,"type":"submit","variant":"success"}},[_vm._v(_vm._s(_vm.dataConfig.titleSingular)+" speichern")]),_vm._v(" "),(_vm.uploadTooLarge)?_c('information',{attrs:{"infoText":'Ihre Bilddateien überschreiten die erlaubten 12 MB.',"extraStyles":'margin-top: -90px;'}}):_vm._e()],1)]):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 704:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid mt-4"},[(_vm.userIsLoggedIn)?_c('b-card',[_c('b-card-header',{staticStyle:{"height":"75px"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"9"}},[_c('h1',{staticClass:"h1"},[_vm._v(_vm._s(_vm.dataConfig.title))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"3"}},[_c('b-alert',{staticStyle:{"margin-top":"5px"},attrs:{"show":_vm.loading,"variant":"info"}},[_vm._v("Lädt Daten...")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('datatable',_vm._b({attrs:{"DataConfig":_vm.dataConfig}},'datatable',_vm.$data,false))],1),_vm._v(" "),_c('b-col',{staticStyle:{"display":"flex"},attrs:{"lg":"4"}},[_c('b-card',{attrs:{"title":'Patient über Datei hinzufügen'}},[_c('input',{ref:"file",staticStyle:{"padding-bottom":"10px"},attrs:{"type":"file","id":"input"}}),_vm._v(" "),_c('b-btn',{on:{"click":function($event){return _vm.loadTextFromFile()}}},[_vm._v("Vorschau laden")])],1),_vm._v(" "),_c('b-alert',{staticStyle:{"margin-top":"5px","margin-bottom":"5px"},attrs:{"show":_vm.loading,"variant":"info"}},[_vm._v("Lädt Daten...")])],1),_vm._v(" "),(_vm.showPreview)?_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',{attrs:{"title":'Vorschau (max. 20 Zeilen)'}},[_c('b-btn',{on:{"click":function($event){return _vm.uploadPatientFile()}}},[_vm._v("Daten hochladen")]),_vm._v(" "),_c('b-btn',{on:{"click":function($event){return _vm.deleteDataPreview()}}},[_vm._v("Daten verwerfen")]),_vm._v(" "),(_vm.warnings.length)?_c('div',{staticStyle:{"margin":"5px"}},[_vm._l((_vm.warnings),function(warn,ind){return _c('p',{key:ind,staticClass:"text-warning",domProps:{"innerHTML":_vm._s(warn)}})}),_vm._v(" "),_c('information',{attrs:{"info-text":("Mögliche Kategorien sind: " + (_vm.headerLabels.join(', ')))}})],2):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.sheetOptions),function(name){return _c('li',{key:name},[_c('a',{on:{"click":function($event){_vm.dataSetName=name}}},[_c('b-nav-item',[_vm._v(" "+_vm._s(name)+" ")])],1)])}),0),_vm._v(" "),_c('datatable',{attrs:{"data":_vm.previewData.slice(0, 20),"columns":_vm.previewColumns,"query":{ limit: 20, offset: 0, sort: 'day_id', order: 'ASC', freeTextFilters: {}, assocFilters: {} },"total":_vm.previewData.length,"HeaderSettings":false,"Pagination":false,"Export":false}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{staticStyle:{"margin-top":"20px"},attrs:{"lg":"12"}},[_c('akribes-form',{attrs:{"dataConfig":_vm.dataConfig,"containsImages":true,"routeID":_vm.routeID}})],1)],1)],1):_c('div',[(!_vm.loading)?_c('NotLoggedIn'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 705:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Exudats_vue__ = __webpack_require__(328);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2aa1c1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Exudats_vue__ = __webpack_require__(706);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Exudats_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f2aa1c1e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Exudats_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 706:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid mt-4"},[(_vm.userIsLoggedIn)?_c('b-card',[_c('b-card-header',{staticStyle:{"height":"75px"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"9"}},[_c('h1',{staticClass:"h1"},[_vm._v(" Experimente ")])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"3"}},[_c('b-alert',{staticStyle:{"margin-top":"5px"},attrs:{"show":_vm.loading,"variant":"info"}},[_vm._v("Lädt Daten...")])],1)],1)],1),_vm._v(" "),_c('ul',{staticClass:"nav nav-tabs",staticStyle:{"margin-top":"20px"}},_vm._l((_vm.tabNames),function(content,tab){return _c('li',{key:tab,class:{ active: (_vm.$route.params.experiment === tab) }},[_c('a',[_c('b-nav-item',{attrs:{"to":'/exudats/' + tab}},[_vm._v(" "+_vm._s(content.titleSingular)+" ")])],1)])}),0),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('router-view')],1)],1):_c('div',[_c('NotLoggedIn')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 707:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proliferation_vue__ = __webpack_require__(329);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c4da0f5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Proliferation_vue__ = __webpack_require__(718);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Proliferation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c4da0f5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Proliferation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 718:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container-fluid mt-4"},[_c('h2',{staticClass:"h2"},[_vm._v(_vm._s(_vm.dataConfig.title))]),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('datatable',_vm._b({attrs:{"DataConfig":_vm.dataConfig}},'datatable',_vm.$data,false))],1),_vm._v(" "),_c('b-col',{staticStyle:{"display":"flex"},attrs:{"lg":"4"}},[_c('b-card',{attrs:{"title":_vm.dataConfig.title + ' über Datei hinzufügen'}},[_c('input',{ref:"file",staticStyle:{"padding-bottom":"10px"},attrs:{"type":"file","id":"input"}}),_vm._v(" "),_c('b-btn',{on:{"click":_vm.loadTextFromFile}},[_vm._v("Vorschau laden")])],1),_vm._v(" "),_c('b-alert',{staticStyle:{"margin-top":"5px","margin-bottom":"5px"},attrs:{"show":_vm.loading,"variant":"info"}},[_vm._v("Lädt Daten...")])],1),_vm._v(" "),(_vm.showPreview)?_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',{attrs:{"title":'Vorschau (max. 10 Zeilen)'}},[_c('b-btn',{on:{"click":function($event){return _vm.submitFile(_vm.experimentName, true)}}},[_vm._v("Daten hochladen")]),_vm._v(" "),_c('b-btn',{on:{"click":function($event){return _vm.deleteDataPreview()}}},[_vm._v("Daten verwerfen")]),_vm._v(" "),(_vm.warnings.length)?_c('div',{staticStyle:{"margin":"5px"}},[_vm._l((_vm.warnings),function(warn,ind){return _c('p',{key:ind,staticClass:"text-warning",domProps:{"innerHTML":_vm._s(warn)}})}),_vm._v(" "),_c('information',{attrs:{"info-text":("Mögliche Kategorien sind: " + (_vm.headerLabels.join(', ')))}})],2):_vm._e(),_vm._v(" "),_c('ul',{staticClass:"nav nav-tabs"},_vm._l((_vm.previewDataSets),function(dataSet,name){return _c('li',{key:name},[_c('a',{on:{"click":function($event){_vm.dataSetName=name}}},[_c('b-nav-item',[_vm._v(" "+_vm._s(name)+" ")])],1)])}),0),_vm._v(" "),_c('datatable',{attrs:{"data":_vm.previewData.slice(0, 10),"columns":_vm.previewColumns,"query":{ limit: 20, offset: 0, sort: 'exudate', order: 'ASC', freeTextFilters: {}, assocFilters: {} },"total":_vm.previewData.length,"HeaderSettings":false,"Pagination":false,"Export":false}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"lg":"12"}},[_c('akribes-form',{attrs:{"dataConfig":_vm.dataConfig,"containsImages":false,"routeID":_vm.routeID}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 719:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrashBin_vue__ = __webpack_require__(336);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f92ca0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrashBin_vue__ = __webpack_require__(720);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TrashBin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18f92ca0_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TrashBin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 720:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid mt-4"},[(_vm.userIsLoggedIn)?_c('b-card',[_c('b-card-header',[_c('h1',{staticClass:"h1"},[_vm._v(" Papierkorb ")])]),_vm._v(" "),_c('ul',{staticClass:"nav nav-tabs",staticStyle:{"margin-top":"20px"}},_vm._l((_vm.tabNames),function(content,tab){return _c('li',{key:tab,class:{ active: (_vm.tableName === tab) }},[_c('a',[_c('b-nav-item',{attrs:{"to":'/trash-bin/' + tab}},[_vm._v(" "+_vm._s(content.title)+" ")])],1)])}),0),_vm._v(" "),_c('b-col',{attrs:{"lg":"12"}},[_c('datatable',_vm._b({attrs:{"DataConfig":_vm.dataConfig}},'datatable',_vm.$data,false))],1)],1):_c('div',[_c('NotLoggedIn')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 721:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Properties_vue__ = __webpack_require__(337);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e08aeb18_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Properties_vue__ = __webpack_require__(722);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Properties_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e08aeb18_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Properties_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 722:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid mt-4"},[(_vm.userIsLoggedIn)?_c('b-card',[_c('b-card-header',{staticStyle:{"height":"75px"}},[_c('b-row',[_c('b-col',{attrs:{"lg":"9"}},[_c('h1',{staticClass:"h1"},[_vm._v(_vm._s(_vm.dataConfig.title))])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"3"}},[_c('b-alert',{staticStyle:{"margin-top":"5px"},attrs:{"show":_vm.loading,"variant":"info"}},[_vm._v("Lädt Daten...")])],1)],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"lg":"12"}},[_c('datatable',_vm._b({attrs:{"DataConfig":_vm.dataConfig}},'datatable',_vm.$data,false))],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-card',{attrs:{"title":_vm.dataConfig.title + ' über Datei hinzufügen'}},[_c('input',{ref:"file",staticStyle:{"padding-bottom":"10px"},attrs:{"type":"file","id":"input"}}),_vm._v(" "),_c('b-btn',{on:{"click":_vm.loadTextFromFile}},[_vm._v("Vorschau laden")])],1),_vm._v(" "),_c('b-alert',{staticStyle:{"margin":"5px"},attrs:{"show":_vm.loading,"variant":"info"}},[_vm._v("Lädt Daten...")])],1),_vm._v(" "),(_vm.showPreview)?_c('b-col',{attrs:{"lg":"12"}},[_c('b-card',{attrs:{"title":'Vorschau (max. 20 Zeilen)'}},[_c('b-btn',{on:{"click":function($event){return _vm.submitFile(_vm.dataConfig.databaseName)}}},[_vm._v("Daten hochladen")]),_vm._v(" "),_c('b-btn',{on:{"click":function($event){return _vm.deleteDataPreview()}}},[_vm._v("Daten verwerfen")]),_vm._v(" "),(_vm.warnings.length)?_c('div',{staticStyle:{"margin":"5px"}},[_vm._l((_vm.warnings),function(warn,ind){return _c('p',{key:ind,staticClass:"text-warning",domProps:{"innerHTML":_vm._s(warn)}})}),_vm._v(" "),_c('information',{attrs:{"info-text":("Mögliche Kategorien sind: " + (_vm.headerLabels.join(', ')))}})],2):_vm._e(),_vm._v(" "),_c('datatable',{attrs:{"data":_vm.previewData.slice(0, 20),"columns":_vm.previewColumns,"query":{ limit: 20, offset: 0, sort: 'option', order: 'ASC', freeTextFilters: {}, assocFilters: {} },"total":_vm.previewData.length,"HeaderSettings":false,"Pagination":false,"Export":false}})],1)],1):_vm._e(),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('akribes-form',{attrs:{"dataConfig":_vm.dataConfig,"containsImages":false,"routeID":_vm.routeID}})],1)],1)],1):_c('div',[(!_vm.loading)?_c('NotLoggedIn'):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 723:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__index_vue__ = __webpack_require__(724);


__WEBPACK_IMPORTED_MODULE_0__index_vue__["a" /* default */].install = function (Vue, options) {
  var locale = options ? options.locale : {};

  // this might be the simplest i18n solution
  Vue.prototype.$i18nForDatatable = function (srcTxt) {
    return locale[srcTxt] || srcTxt;
  };

  Vue.component('Datatable', __WEBPACK_IMPORTED_MODULE_0__index_vue__["a" /* default */]);
};

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(__WEBPACK_IMPORTED_MODULE_0__index_vue__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__index_vue__["a" /* default */]);

/***/ }),

/***/ 724:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(338);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69db6b64_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(867);
function injectStyle (ssrContext) {
  __webpack_require__(725)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69db6b64_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 725:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 729:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(339);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605c8100_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(826);
function injectStyle (ssrContext) {
  __webpack_require__(730)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_605c8100_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 730:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 731:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColumnGroup_vue__ = __webpack_require__(340);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f6b000_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColumnGroup_vue__ = __webpack_require__(733);
function injectStyle (ssrContext) {
  __webpack_require__(732)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ColumnGroup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f6b000_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ColumnGroup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 732:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 733:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"-col-group",attrs:{"name":"ColumnGroup"}},[_c('label',{staticClass:"-col-group-title"},[_vm._v("\n    "+_vm._s(_vm.groupName === 'undefined' ? 'Columns' : _vm.groupName)+"\n  ")]),_vm._v(" "),_vm._l((_vm.columns),function(col,idx){return _c('li',[_c('input',{attrs:{"type":"checkbox","id":_vm.uuidGen(col.field || idx),"name":_vm.groupName,"disabled":typeof col.visible === 'string'},domProps:{"checked":_vm.isColVisible(col)},on:{"change":function($event){return _vm.handleChange(col, $event.target.checked)}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.uuidGen(col.field || idx)}},[_vm._v("\n      "+_vm._s(col.label || col.title)+"\n      "),(col.explain)?_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"cursor":"help"},attrs:{"title":col.explain}}):_vm._e()])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 824:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// https://stackoverflow.com/a/7616484/5172890
/* harmony default export */ __webpack_exports__["a"] = (function (s) {
  var hash = 0;
  for (var i = 0; i < s.length; i++) {
    hash = (hash << 5) - hash + s.charCodeAt(i);
    hash |= 0;
  }
  return '' + hash;
});

/***/ }),

/***/ 825:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return parseStr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stringify; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return saveToLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return rmFromLS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getFromLS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);

var LS = localStorage;

var parseStr = JSON.parse;

var stringify = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default.a;

var saveToLS = function saveToLS(k, v) {
  LS.setItem(k, stringify(v));
};

var rmFromLS = function rmFromLS(k) {
  LS.removeItem(k);
};

var getFromLS = function getFromLS(k) {
  try {
    return parseStr(LS.getItem(k));
  } catch (e) {
    rmFromLS(k);
  }
};

/***/ }),

/***/ 826:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group",attrs:{"name":"HeaderSettings"}},[_c('button',{ref:"dropdownBtn",staticClass:"btn btn-default dropdown-toggle",attrs:{"type":"button"}},[_c('i',{staticClass:"fa",class:['fa-cog', { filterIsActive: _vm.filterIsActive}]})]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu clearfix",style:(_vm.drpMenuStyle)},[_c('div',{staticClass:"-col-group-container"},_vm._l((_vm.colGroups),function(columns,groupName){return _c('column-group',{key:groupName,ref:"colGroups",refInFor:true,attrs:{"group-name":groupName,"columns":columns}})}),1),_vm._v(" "),_c('div',{staticClass:"clearfix",staticStyle:{"margin":"10px 0"}},[_c('div',{staticClass:"btn-group btn-group-sm pull-right"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.apply()}}},[_vm._v("\n          "+_vm._s(_vm.$i18nForDatatable('Apply'))+"\n        ")]),_vm._v(" "),(_vm.supportBackup)?[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',{on:{"click":function($event){return _vm.apply(true)}}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_c('i',{staticClass:"fa fa-floppy-o"}),_vm._v(" \n                "+_vm._s(_vm.$i18nForDatatable('Apply and backup settings to local'))+"\n              ")])]),_vm._v(" "),(_vm.usingBak)?_c('li',{on:{"click":function($event){return _vm.rmBackup()}}},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_c('i',{staticClass:"fa fa-trash-o text-danger"}),_vm._v(" \n                "+_vm._s(_vm.$i18nForDatatable('Clear local settings backup and restore'))+"\n              ")])]):_vm._e()])]:_vm._e()],2)]),_vm._v(" "),(_vm.usingBak)?_c('small',{staticClass:"pull-left text-muted",staticStyle:{"margin-top":"-8px"}},[_vm._v("\n      ( "+_vm._s(_vm.$i18nForDatatable('Using local settings'))+" )\n    ")]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-default dropdown-toggle",staticStyle:{"box-shadow":"none"},attrs:{"data-toggle":"dropdown","type":"button"}},[_c('span',{staticClass:"caret"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 827:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelect_vue__ = __webpack_require__(360);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05351eec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiSelect_vue__ = __webpack_require__(832);
function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_05351eec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 828:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 829:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_MultiSelect_vue__ = __webpack_require__(361);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb8d851c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_MultiSelect_vue__ = __webpack_require__(831);
function injectStyle (ssrContext) {
  __webpack_require__(830)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_MultiSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bb8d851c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_MultiSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 830:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 831:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"-col-group",staticStyle:{"display":"inline-block","width":"220px"},attrs:{"name":"ListMS"}},[_c('div',{staticClass:"-col-group-title"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.isAllSelected},on:{"change":function($event){return _vm.selectAll(_vm.isAllSelected)}}}),_vm._v(" "),_c('label',{staticClass:"MS-label"},[_vm._v("\n      "+_vm._s(_vm.groupName)+"\n    ")])]),_vm._v(" "),_vm._l((_vm.elements),function(el){return _c('li',{key:el.field,staticStyle:{"display":"flex"}},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":el.isChecked},on:{"change":function($event){return _vm.handleChange(el, $event.target.checked)}}}),_vm._v(" "),_c('label',{staticClass:"MS-label"},[_vm._v("\n      "+_vm._s(el.title)+"\n    ")])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 832:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn-group",attrs:{"name":"MultiSelect"}},[_c('div',[_c('button',{ref:"dropdownBtn",staticClass:"form-control btn btn-default dropdown-toggle ms-dropdown",attrs:{"id":_vm.filteredValue,"type":"button"},on:{"click":function($event){_vm.showDropdown = !_vm.showDropdown}}},[_c('i',{staticClass:"fa fa-cog",class:{ 'filterIsActive': !_vm.isAllSelected }})])]),_vm._v(" "),(_vm.showDropdown)?_c('div',{style:(_vm.drpMenuStyle)},[_c('div',[(_vm.hasMultipleGroups)?_c('div',{staticClass:"-col-group-title"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"checked":_vm.allFieldsSelected},on:{"change":function($event){return _vm.selectAllFields(_vm.allFieldsSelected)}}}),_vm._v(" "),_c('label',{staticStyle:{"text-transform":"none"}},[_vm._v(" Alle auswählen ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"-col-group-container"},_vm._l((_vm.colGroups),function(fields,groupName){return _c('ListMS',{key:groupName,ref:"colGroups",refInFor:true,attrs:{"group-name":(groupName === 'undefined') ? 'Alle auswählen' : groupName,"elements":fields,"globChanges":_vm.globalChanges[groupName],"categories":_vm.categories,"nChanges":_vm.nChanges}})}),1)]),_vm._v(" "),_c('div',{staticClass:"clearfix",staticStyle:{"margin":"10px 0"}},[_c('div',{staticClass:"btn-group btn-group-sm pull-right"},[_c('button',{staticClass:"btn btn-default",attrs:{"type":"button"},on:{"click":function($event){return _vm.apply()}}},[_vm._v("\n          "+_vm._s(_vm.$i18nForDatatable('Anwenden'))+"\n        ")])])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 833:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(362);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f8d4e23_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(856);
function injectStyle (ssrContext) {
  __webpack_require__(834)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f8d4e23_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 834:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 835:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableFrame_vue__ = __webpack_require__(363);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14bbfb05_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableFrame_vue__ = __webpack_require__(836);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableFrame_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14bbfb05_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableFrame_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 836:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table table-striped table-hover table-bordered",class:_vm.tblClass,staticStyle:{"margin-bottom":"0"},style:(_vm.tblStyle)},[_c('colgroup',[(_vm.shouldRenderSelection)?_c('col',{staticStyle:{"width":"30px"}}):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(col){return _c('col',{class:col.colClass,style:(col.colStyle)})})],2),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 837:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableHeader_vue__ = __webpack_require__(364);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c773911_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableHeader_vue__ = __webpack_require__(841);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c773911_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 838:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeadSort_vue__ = __webpack_require__(365);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a48dc3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeadSort_vue__ = __webpack_require__(839);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HeadSort_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14a48dc3_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HeadSort_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 839:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#","name":"HeadSort"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick.apply(null, arguments)}}},[_c('i',{class:_vm.cls})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 840:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticStyle:{"margin":"0","vertical-align":"middle"},attrs:{"type":"checkbox","name":"MultiSelect"},domProps:{"checked":Array.isArray(_vm.status)?_vm._i(_vm.status,null)>-1:(_vm.status)},on:{"change":[function($event){var $$a=_vm.status,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.status=$$a.concat([$$v]))}else{$$i>-1&&(_vm.status=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.status=$$c}},_vm.toggle]}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 841:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('transition-group',{attrs:{"name":"fade","tag":"tr"}},[(_vm.shouldRenderSelection)?_c('th',{key:"--th-multi"},[_c('multi-select',{attrs:{"selection":_vm.selection,"rows":_vm.data}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(col,idx){return _c('th',{key:col.title || col.field || idx,class:col.thClass,style:(col.thComp)},[_c('label',{staticStyle:{"text-transform":"none"}},[(_vm.shownCategories.includes(col.category))?_c('div',[_vm._v("\n        "+_vm._s(col.category)+":\n      ")]):_vm._e(),_vm._v("\n        "+_vm._s(col.title)+"\n      ")]),_vm._v(" "),(col.thComp)?_c(_vm.forDynCompIs(col.thComp),_vm._b({tag:"component",attrs:{"column":col,"field":col.field,"title":col.title,"items":col.items,"filterType":col.filterType}},'component',_vm.$props,false)):_vm._e(),_vm._v(" "),(col.explain)?_c('i',{staticClass:"fa fa-info-circle",staticStyle:{"cursor":"help"},attrs:{"title":col.explain}}):_vm._e(),_vm._v(" "),(col.sortable)?_c('head-sort',{attrs:{"field":col.field,"query":_vm.query}}):_vm._e()],1)}),_vm._v(" "),(_vm.Pagination && !_vm.isTrashBin)?_c('th',{key:'1'},[void 0],2):_vm._e(),_vm._v(" "),(_vm.Pagination && !_vm.isTrashBin)?_c('th',{key:'2'},[void 0],2):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 842:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableBody_vue__ = __webpack_require__(368);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c3872d9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableBody_vue__ = __webpack_require__(845);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableBody_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c3872d9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableBody_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 844:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 845:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tbody',[(_vm.data.length)?[_vm._l((_vm.data),function(item){return [_c('tr',{key:item.id},[(_vm.shouldRenderSelection)?_c('td',[_c('multi-select',{attrs:{"selection":_vm.selection,"row":item}})],1):_vm._e(),_vm._v(" "),_vm._l((_vm.shownCols),function(col){return _c('td',{key:col.field,class:col.tdClass,style:(col.tdStyle)},[(col.tdComp)?_c(_vm.forDynCompIs(col.tdComp),_vm._b({tag:"component",attrs:{"row":item,"field":col.field,"value":item[col.field],"nested":item.__nested__}},'component',_vm.$props,false)):_vm._e(),_vm._v(" "),(['created_at', 'updated_at', 'createdAt', 'updatedAt', 'deleted_at', 'restored_at', 'date'].includes(col.field) && item[col.field] !== null)?[_vm._v("\n            "+_vm._s(new Date(item[col.field]).toLocaleDateString())+"\n          ")]:(col.field==='photo_time' && item[col.field] !== null)?[_vm._v("\n            "+_vm._s(new Date(item[col.field]).toLocaleTimeString())+"\n          ")]:(typeof item[col.field] === 'boolean' && item[col.field] !== null)?[_vm._v("\n            "+_vm._s((item[col.field]) ? 'Ja' : 'Nein')+"\n          ")]:(typeof item[col.field] === 'object' && item[col.field] !== null)?[_vm._v("\n            "+_vm._s(item[col.field].join(', '))+"\n          ")]:(col.field==='photo_path' && item[col.field] !== null)?[_c('vue-pure-lightbox',{staticStyle:{"width":"4em"},attrs:{"thumbnail":_vm.getListOfImages(item[col.field])[0],"images":_vm.getListOfImages(item[col.field])}}),_vm._v(" "),(_vm.getListOfImages(item[col.field]).filter(function (im) { return im; }).length)?_c('center',{staticStyle:{"text-align":"center"}},[_vm._v("\n              ( "+_vm._s(_vm.getListOfImages(item[col.field]).filter(function (im) { return im; }).length)+" )\n            ")]):_vm._e()]:(typeof item[col.field] === 'number' && item[col.field] !== 'null')?[_vm._v("\n            "+_vm._s(Math.round(item[col.field] * 10) / 10)+"\n          ")]:(item[col.field] !== 'null')?[_vm._v("\n            "+_vm._s(item[col.field])+"\n          ")]:_vm._e()],2)}),_vm._v(" "),(_vm.Pagination && !_vm.isTrashBin)?_c('td',[[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.populatePostToEdit(item)}}},[_vm._v("Bearbeiten")])]],2):_vm._e(),_vm._v(" "),(_vm.Pagination && !_vm.isTrashBin)?_c('td',[[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.deletePost(item)}}},[_vm._v("Löschen")])]],2):_vm._e()],2),_vm._v(" "),_c('transition',{key:item.id,attrs:{"name":"fade"}},[(item.__nested__ && item.__nested__.visible)?_c('tr',[_c('td',{attrs:{"colspan":_vm.colLen}},[_c(_vm.forDynCompIs(item.__nested__.comp),_vm._b({tag:"component",attrs:{"row":item,"nested":item.__nested__}},'component',_vm.$props,false))],1)]):_vm._e()])]})]:(!_vm.leftFixed && !_vm.rightFixed)?_c('tr',[_c('td',{staticClass:"text-center text-muted",attrs:{"colspan":_vm.colLen}},[_vm._v("\n      ( "+_vm._s(_vm.$i18nForDatatable('Keine Daten vorhanden'))+" )\n    ")])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 846:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableFooter_vue__ = __webpack_require__(369);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5875a50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableFooter_vue__ = __webpack_require__(848);
function injectStyle (ssrContext) {
  __webpack_require__(847)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TableFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d5875a50_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TableFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 847:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 848:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tfoot',{directives:[{name:"show",rawName:"v-show",value:(_vm.data.length),expression:"data.length"}]},[_c('tr',{staticClass:"-summary-row"},[(_vm.shouldRenderSelection)?_c('td'):_vm._e(),_vm._v(" "),_vm._l((_vm.columns),function(col,idx){return [(typeof _vm.summary[col.field] !== 'undefined')?_c('td',{class:col.tdClass,style:(col.tdStyle)},[(col.tdComp)?_c(_vm.forDynCompIs(col.tdComp),_vm._b({tag:"component",attrs:{"row":_vm.summary,"field":col.field,"value":_vm.summary[col.field]}},'component',_vm.$props,false)):[_vm._v("\n          "+_vm._s(_vm.summary[col.field])+"\n        ")]],2):_c('td')]})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 849:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Refers to https://davidwalsh.name/detect-scrollbar-width
var scrollWidth = void 0;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (scrollWidth) {
    return scrollWidth;
  }

  var div = document.createElement('div');

  div.style.width = '100px';
  div.style.height = '100px';
  div.style.overflow = 'scroll';
  div.style.position = 'absolute';
  div.style.top = '-9999px';

  document.body.appendChild(div);

  scrollWidth = div.offsetWidth - div.clientWidth;

  document.body.removeChild(div);

  return scrollWidth;
});

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    columns: { type: Array, required: true },
    data: { type: Array, required: true }, // rows
    total: { type: Number, required: true },
    query: { type: Object, required: true },
    selection: Array, // container for multi-select
    summary: Object, // an extra summary row
    xprops: Object, // extra custom props carrier passed to dynamic components
    HeaderSettings: { type: Boolean, default: true }, // whether to render `HeaderSettings`
    Pagination: { type: Boolean, default: true }, // whether to render `PageSizeSelect` and `Pagination`
    Export: { type: Boolean, default: true }, // whether to render Buttons to Export .xlsx and .csv
    pageSizeOptions: { type: Array, default: function _default() {
        return [10, 20, 40, 80, 100];
      } },
    tblClass: [String, Object, Array], // classes for <table>
    tblStyle: [String, Object, Array], // inline styles for <table>
    fixHeaderAndSetBodyMaxHeight: Number, // a fancy prop which combines two props into one
    supportNested: [Boolean, String], // support nested components feature (String is only for 'accordion')
    supportBackup: Boolean, // support backup for `HeaderSettings`
    DataConfig: Object,
    isTrashBin: { type: Boolean, default: false // whether this is the Trash Bin Table
    } },
  data: function data() {
    var datatableInstance = this;
    while (datatableInstance.$options.name !== 'Datatable') {
      datatableInstance = datatableInstance.$parent;
    }
    return {
      // the source of dynamic components (thComp / tdComp / nested components)
      comp: datatableInstance.$parent.$options.components
    };
  },

  methods: {
    // usage: <component :is="forDynCompIs(XXX)" ... />
    forDynCompIs: function forDynCompIs(component) {
      // according to https://vuejs.org/v2/guide/components.html#Dynamic-Components
      // dynamic components can be names (string) or component objects
      return (typeof component === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(component)) === 'object' ? component : this.comp[component];
    }
  }
});

/***/ }),

/***/ 850:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);




/**
 * synchronize the scroll position among `els`
 * @param  {DOM[]} els
 * @param  {Func}  callback(offsetLeft)
 * @return {Func}  unsync
 */
/* harmony default export */ __webpack_exports__["a"] = (function (els, callback) {
  var currentDriver = void 0;

  function syncScroll(me, others) {
    me.on('scroll', __WEBPACK_IMPORTED_MODULE_0_lodash_throttle___default()(function () {
      if (currentDriver && currentDriver !== me) return;
      currentDriver = me;

      var offsetLeft = me.scrollLeft();
      others.scrollLeft(offsetLeft);

      callback(offsetLeft);
    }))
    // scroll stops
    .on('scroll', __WEBPACK_IMPORTED_MODULE_1_lodash_debounce___default()(function () {
      currentDriver = null;
    }, 150));

    // unlistener
    return function () {
      me.off('scroll');
    };
  }

  var unlisteners = els.map(function (me, idx) {
    var others = els.slice();
    others.splice(idx, 1); // exclude me
    return syncScroll(__WEBPACK_IMPORTED_MODULE_2_jquery___default()(me), __WEBPACK_IMPORTED_MODULE_2_jquery___default()(others));
  });

  // unsync
  return function () {
    unlisteners.forEach(function (unlistener) {
      unlistener();
    });
  };
});

/***/ }),

/***/ 856:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.useComplexMode)?_c('div',{staticClass:"-complex-table",attrs:{"name":"ComplexTable"}},[_vm._l((['Header', 'Body', 'Footer']),function(x){return [(x !== 'Footer' || x === 'Footer' && _vm.summary)?_c('div',{ref:"wrappers",refInFor:true,class:("-table-" + (x.toLowerCase())),style:([
        x !== 'Header' && { marginTop: ("-" + _vm.scrollWidth + "px") },
        x === 'Body' && { maxHeight: (_vm.fixHeaderAndSetBodyMaxHeight + "px") }
      ]),attrs:{"name":("Table" + x + "Wrapper")}},[_c('div',{attrs:{"name":("NormalTable" + x)}},[_c('table-frame',_vm._b({},'table-frame',_vm.propsToNormalTable,false),[_c(("Table" + x),_vm._b({tag:"component"},'component',_vm.propsToNormalTable,false))],1)],1),_vm._v(" "),(_vm.leftFixedColumns.length)?_c('div',{staticClass:"-left-fixed -fixed-table",style:({ left: (_vm.offsetLeft + "px") }),attrs:{"name":("LeftFixedTable" + x)}},[_c('table-frame',_vm._b({attrs:{"left-fixed":""}},'table-frame',_vm.propsToLeftFixedTable,false),[_c(("Table" + x),_vm._b({tag:"component",attrs:{"left-fixed":""}},'component',_vm.propsToLeftFixedTable,false))],1)],1):_vm._e(),_vm._v(" "),(_vm.rightFixedColumns.length)?_c('div',{staticClass:"-right-fixed -fixed-table",style:({ right: ("-" + _vm.offsetLeft + "px") }),attrs:{"name":("RightFixedTable" + x)}},[_c('table-frame',_vm._b({attrs:{"right-fixed":""}},'table-frame',_vm.propsToRightFixedTable,false),[_c(("Table" + x),_vm._b({tag:"component",attrs:{"right-fixed":""}},'component',_vm.propsToRightFixedTable,false))],1)],1):_vm._e()]):_vm._e()]})],2):_c('div',{attrs:{"name":"SimpleTable"}},[_c('table-frame',_vm._b({},'table-frame',_vm.propsToNormalTable,false),[_c('table-header',_vm._b({},'table-header',_vm.propsToNormalTable,false)),_vm._v(" "),_c('table-body',_vm._b({},'table-body',_vm.propsToNormalTable,false)),_vm._v(" "),(_vm.summary)?_c('table-footer',_vm._b({},'table-footer',_vm.propsToNormalTable,false)):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 857:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__ = __webpack_require__(371);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46f966b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__ = __webpack_require__(858);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Pagination_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_46f966b4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Pagination_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 858:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"pagination",staticStyle:{"margin":"0"},attrs:{"name":"Pagination"}},[(!_vm.isFirstPage)?_c('li',{staticClass:"page-item",on:{"click":function($event){return _vm.turnPage(-1)}}},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_c('i',{staticClass:"fa fa-arrow-left"})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.dspBtnObjs),function(i){return _c('li',{key:i.i,class:['page-item', { 'active': i.btn === _vm.curPage }]},[(i.btn)?_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.handleClick(i.btn)}}},[_vm._v("\n      "+_vm._s(i.btn)+"\n    ")]):_c('a',{staticClass:"page-link"},[_c('i',{staticClass:"fa fa-ellipsis-h"})])])}),_vm._v(" "),(!_vm.isLastPage)?_c('li',{staticClass:"page-item",on:{"click":function($event){return _vm.turnPage(1)}}},[_c('a',{staticClass:"page-link",attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();}}},[_c('i',{staticClass:"fa fa-arrow-right"})])]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 859:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSizeSelect_vue__ = __webpack_require__(372);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa3769ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageSizeSelect_vue__ = __webpack_require__(861);
function injectStyle (ssrContext) {
  __webpack_require__(860)
}
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PageSizeSelect_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fa3769ea_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PageSizeSelect_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 860:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 861:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"name":"PageSizeSelect"}},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.query.limit),expression:"query.limit"}],staticClass:"form-control input-sm -page-size-select",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.query, "limit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])},function($event){_vm.query.offset = 0; _vm.query.nChanges += 1 /* reset to the first page */}]}},_vm._l((_vm.pageSizeOptions),function(i){return _c('option',{key:i,domProps:{"value":i}},[_vm._v(_vm._s(i))])}),0),_vm._v("\n  "+_vm._s(_vm.$i18nForDatatable('Einträge / Seite'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 862:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportButtons_vue__ = __webpack_require__(373);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b531cb9c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportButtons_vue__ = __webpack_require__(866);
var normalizeComponent = __webpack_require__(19)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExportButtons_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b531cb9c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ExportButtons_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 863:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = exportCsv;
var Json2csvParser = __webpack_require__(864).Parser;

function exportCsv(data, fields, fileName) {
  try {
    var parser = new Json2csvParser({ fields: fields, delimiter: ';' });
    var csv = parser.parse(data);

    var csvContent = 'data:text/csvcharset=GBK,\uFEFF' + csv;
    var encodedUri = encodeURI(csvContent);
    var link = document.createElement('a');
    link.setAttribute('href', encodedUri);
    link.setAttribute('download', (fileName || 'file') + '.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error(err);
  }
}

/***/ }),

/***/ 865:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = exportXls;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

var xlsx = __webpack_require__(320);

function exportXls(data, fields, fileName, params) {
  try {
    var filteredData = data.map(function (row) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(row).filter(function (key) {
        return fields.includes(key);
      }).reduce(function (obj, key) {
        if (typeof row[key] === 'boolean') obj[key] = row[key] ? 'Ja' : 'Nein';else if (key.toLowerCase().includes('datum')) obj[key] = new Date(row[key]).toLocaleDateString(); // Format Date String
        else if (key.toLowerCase().includes('uhrzeit') && row[key]) {
            obj[key] = new Date(row[key]).toLocaleTimeString(); // Format Time String
          } else obj[key] = row[key];
        return obj;
      }, {});
    });

    var wb = xlsx.utils.book_new();
    wb.SheetNames.push('Tabelle');
    wb.Sheets['Tabelle'] = xlsx.utils.json_to_sheet(filteredData, { header: fields }); // Header: Provide desired column order

    if (params) {
      wb.SheetNames.push('Einstellungen');
      wb.Sheets['Einstellungen'] = xlsx.utils.aoa_to_sheet(params);
    }

    xlsx.writeFile(wb, fileName + '.xlsx');
  } catch (err) {
    console.error(err);
  }
}

/***/ }),

/***/ 866:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-right",staticStyle:{"margin-top":"10px","margin-bottom":"10px"}},[(_vm.showCSV)?_c('button',{staticClass:"btn btn-default",on:{"click":_vm.exportCsv}},[_vm._v(_vm._s(_vm.whatIsExported)+" als CSV exportieren")]):_vm._e(),_vm._v(" "),(_vm.showXLSX)?_c('button',{staticClass:"btn btn-default",on:{"click":_vm.exportXlsx}},[_vm._v(_vm._s(_vm.whatIsExported)+" als Excel exportieren")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 867:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":"Datatable"}},[(_vm.Pagination)?_c('MultiSelect',{staticStyle:{"padding-top":"10px","padding-bottom":"10px"},attrs:{"fields":_vm.columns}}):_vm._e(),_vm._v(" "),_c('div',{staticStyle:{"overflow-x":"scroll","padding-left":"0px"}},[(_vm.$slots.default || _vm.HeaderSettings)?_c('div',{staticStyle:{"margin-bottom":"10px"}},[_c('div',{staticStyle:{"height":"25px"}},_vm._l((_vm.currentFilters),function(fil){return _c('b-btn',{key:fil.db_key,staticClass:"btn btn-round btn-filter",on:{"click":function($event){return _vm.resetFilter(fil.db_key)}}},[_vm._v("\n          "+_vm._s(fil.label)+"\n          "),_c('i',{staticClass:"fa fa-times-circle"})])}),1),_vm._v(" "),_c('div',{staticStyle:{"display":"grid"}},[_c('b-btn',{staticClass:"akribes-btn btn-sm",on:{"click":_vm.resetSettings}},[_vm._v("\n          Einstellungen zurücksetzen\n        ")]),_vm._v(" "),_c('b-btn',{staticClass:"akribes-btn btn-sm",on:{"click":_vm.resetAllFilters}},[_vm._v("\n          Alle Filter zurücksetzen\n        ")]),_vm._v(" "),(_vm.isTrashBin)?_c('b-btn',{staticClass:"akribes-btn btn-sm",on:{"click":function($event){return _vm.restoreSelection()}}},[_vm._v("\n          Ausgewählte Zeilen wiederherstellen\n        ")]):_vm._e(),_vm._v(" "),(_vm.isTrashBin)?_c('b-btn',{staticClass:"akribes-btn btn-sm",staticStyle:{"background-color":"darkred"},on:{"click":function($event){return _vm.deleteSelection(_vm.isTrashBin)}}},[_vm._v("\n          Ausgewählte Zeilen endgültig löschen\n        ")]):_c('b-btn',{staticClass:"akribes-btn btn-sm",on:{"click":function($event){return _vm.deleteSelection(_vm.isTrashBin)}}},[_vm._v("\n          Ausgewählte Zeilen löschen\n        ")])],1),_vm._v(" "),_vm._t("default")],2):_vm._e(),_vm._v(" "),_c('tbl',_vm._b({staticStyle:{"overflow":"visible"}},'tbl',_vm.$props,false))],1),_vm._v(" "),(_vm.Pagination)?_c('div',{staticClass:"row",staticStyle:{"margin-top":"10px"}},[_c('div',{staticClass:"col-sm-6",staticStyle:{"white-space":"nowrap"}},[_c('strong',[_vm._v("\n        "+_vm._s(_vm.$i18nForDatatable('Insgesamt'))+" "+_vm._s(_vm.total)+" "+_vm._s(_vm.$i18nForDatatable(','))+"\n      ")]),_vm._v(" "),_c('page-size-select',{attrs:{"query":_vm.query,"page-size-options":_vm.pageSizeOptions}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-6"},[_c('pagination',{staticClass:"pull-right",attrs:{"total":_vm.total,"query":_vm.query}})],1)]):_vm._e(),_vm._v(" "),(_vm.Export)?_c('ExportButtons',{attrs:{"columns":_vm.columns,"query":_vm.query,"config":_vm.DataConfig,"selection":_vm.selection}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 906:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[521]);


// WEBPACK FOOTER //
// static/js/app.18d736ba8292b96676dc.js